/* ============================================================
   StatMed Firebase client
   Loads Firebase SDK from CDN and exposes a small namespaced API
   on window.StatMed.fb for sections to consume.

   Config is read from window.StatMedConfig.firebase (injected by
   theme.liquid from theme settings). If no config is present the
   client runs in "mock" mode and serves deterministic sample data
   so the UI is fully previewable inside the Shopify theme editor.
   ============================================================ */
(function () {
  var SM_FB_VERSION = 'v2.1-admin';
  try { console.info('[StatMed] firebase.js loaded — ' + SM_FB_VERSION); } catch (e) {}

  const FALLBACK_LOCATIONS = [
    { id: 'lake-city',   name: 'Lake City',   city: 'Lake City, FL',   address: 'Lake City, Florida',   hours: 'Mon–Fri 8am–5pm' },
    { id: 'gainesville', name: 'Gainesville', city: 'Gainesville, FL', address: 'Gainesville, Florida', hours: 'Mon–Fri 8am–5pm' },
    { id: 'jacksonville',name: 'Jacksonville',city: 'Jacksonville, FL',address: 'Jacksonville, Florida',hours: 'Mon–Sat 8am–6pm' }
  ];

  const namespace = (window.StatMed = window.StatMed || {});
  const cfg = (window.StatMedConfig = window.StatMedConfig || {});

  // ============================================================
  // 🔧 HARDCODED FALLBACK FIREBASE CONFIG
  // ------------------------------------------------------------
  // If theme settings → StatMed — Firebase aren't reaching the page
  // (theme.liquid is stale, etc.), paste your Firebase web app
  // config values directly here and save. Leave the strings empty
  // to use theme settings instead.
  // Get the values from:
  //   Firebase console → Project settings → General → Your apps → Web
  // ============================================================
  const HARDCODED_FIREBASE_CONFIG = {
  apiKey: "AIzaSyBG74RMGZv4EZoOe1xd1uoCBXITpq_OjmQ",
  authDomain: "stat-med-training.firebaseapp.com",
  projectId: "stat-med-training",
  storageBucket: "stat-med-training.firebasestorage.app",
  messagingSenderId: "368938558162",
  appId: "1:368938558162:web:b4a5d0581309cff884830b",
  measurementId: "G-6N1LGNLLFE"
};

  const themeCfg = cfg.firebase && cfg.firebase.apiKey ? cfg.firebase : null;
  const firebaseCfg = themeCfg || (HARDCODED_FIREBASE_CONFIG.apiKey ? HARDCODED_FIREBASE_CONFIG : null);

  const hasConfig = !!(firebaseCfg && firebaseCfg.apiKey && firebaseCfg.projectId);

  const state = {
    ready: false,
    mock: !hasConfig,
    db: null,
    storage: null,
    auth: null
  };

  const listeners = [];

  function onReady(cb) {
    if (state.ready) cb(state); else listeners.push(cb);
  }

  function markReady() {
    state.ready = true;
    try {
      console.info('[StatMed] Firebase ready. mode=' + (state.mock ? 'MOCK (no config or init failed)' : 'LIVE') + '. projectId=' + (firebaseCfg && firebaseCfg.projectId ? firebaseCfg.projectId : '(none)'));
    } catch (e) {}
    listeners.splice(0).forEach((cb) => { try { cb(state); } catch (e) { console.error(e); } });
  }

  // Cryptographically random URL-safe token for public quote links.
  // 18 bytes of randomness → 24 base64 chars. No padding, no '+' or '/'.
  function genPublicToken() {
    const bytes = new Uint8Array(18);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    return btoa(String.fromCharCode.apply(null, bytes))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  async function initFirebase() {
    if (!hasConfig) { markReady(); return; }
    try {
      const v = '10.12.0';
      // Load compat builds so we don't need a bundler.
      await loadScript(`https://www.gstatic.com/firebasejs/${v}/firebase-app-compat.js`);
      await Promise.all([
        loadScript(`https://www.gstatic.com/firebasejs/${v}/firebase-firestore-compat.js`),
        loadScript(`https://www.gstatic.com/firebasejs/${v}/firebase-auth-compat.js`),
        loadScript(`https://www.gstatic.com/firebasejs/${v}/firebase-storage-compat.js`)
      ]);
      if (!window.firebase.apps.length) window.firebase.initializeApp(firebaseCfg);
      state.db = window.firebase.firestore();
      state.auth = window.firebase.auth();
      state.storage = window.firebase.storage();
    } catch (e) {
      console.warn('[StatMed] Firebase init failed, falling back to mock mode', e);
      state.mock = true;
    }
    markReady();
  }

  /* ---------- Mock data generation ---------- */
  function mockSlotsFor(locationId, serviceId, daysAhead = 21) {
    // Deterministic pseudo-random based on date + location so previews are stable.
    function seeded(n) { const x = Math.sin(n) * 10000; return x - Math.floor(x); }
    const results = [];
    const base = new Date();
    base.setHours(0, 0, 0, 0);
    for (let i = 1; i <= daysAhead; i++) {
      const d = new Date(base.getTime() + i * 86400000);
      if (d.getDay() === 0) continue; // no Sunday classes
      if (locationId === 'lake-city' && d.getDay() === 6) continue; // Lake City closed Saturday
      const key = d.getFullYear() * 10000 + d.getMonth() * 100 + d.getDate();
      const seed = key + locationId.length + (serviceId || '').length;
      const count = 1 + Math.floor(seeded(seed) * 3);
      const slots = [];
      const hours = [9, 11, 13, 15];
      for (let h = 0; h < count; h++) {
        const hour = hours[h] || 9;
        const seatsLeft = Math.max(0, Math.floor(seeded(seed + h) * 8));
        slots.push({
          startsAt: new Date(d.getFullYear(), d.getMonth(), d.getDate(), hour, 0).toISOString(),
          seatsLeft,
          seatsTotal: 8
        });
      }
      results.push({ date: d.toISOString().slice(0, 10), slots });
    }
    return results;
  }

  // Eastern (America/New_York) YYYY-MM-DD — "today" for class/time-off
  // cut-offs. toISOString() is UTC and rolls over at 8 PM Eastern.
  function easternToday() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  // Resolve an employees doc by login/work email (staff-readable only;
  // returns null when the caller can't read employees).
  async function findEmployeeByEmail(email) {
    const em = String(email || '').trim().toLowerCase();
    if (!em || state.mock || !state.db) return null;
    for (const field of ['email', 'loginEmail']) {
      try {
        const snap = await state.db.collection('employees').where(field, '==', em).limit(1).get();
        if (!snap.empty) { const d = snap.docs[0]; return Object.assign({ id: d.id }, d.data()); }
      } catch (e) { return null; }
    }
    return null;
  }
  function employeeDisplayName(e) {
    return e ? ([(e.preferredName || e.firstName || ''), e.lastName || ''].join(' ').trim() || e.email || '') : '';
  }

  function mockCnaClasses(locationId) {
    const base = new Date();
    base.setHours(0, 0, 0, 0);
    const pick = (dayOffset) => new Date(base.getTime() + dayOffset * 86400000).toISOString().slice(0, 10);
    return [
      {
        id: 'cna-' + locationId + '-1',
        startDate: pick(14),
        endDate: pick(14 + 12),
        days: 10,
        startTime: '08:30',
        endTime: '16:00',
        schedule: 'Mon–Fri over 2 weeks',
        seatsLeft: 6,
        seatsTotal: 12
      },
      {
        id: 'cna-' + locationId + '-2',
        startDate: pick(35),
        endDate: pick(35 + 26),
        days: 10,
        startTime: '17:30',
        endTime: '21:30',
        schedule: 'Evenings, Tue/Thu over 5 weeks',
        seatsLeft: 9,
        seatsTotal: 12
      }
    ];
  }

  /* ---------- Public API ---------- */
  const api = {
    isMock: () => state.mock,
    onReady,

    async getLocations() {
      await ready();
      if (state.mock || !state.db) return FALLBACK_LOCATIONS.slice();
      const snap = await state.db.collection('locations').orderBy('name').get();
      const list = [];
      snap.forEach((d) => list.push(Object.assign({ id: d.id }, d.data())));
      return list.length ? list : FALLBACK_LOCATIONS.slice();
    },

    async getService(serviceId) {
      await ready();
      if (!serviceId) return null;
      if (state.mock || !state.db) return null;
      try {
        const snap = await state.db.collection('services').doc(serviceId).get();
        return snap.exists ? Object.assign({ id: snap.id }, snap.data()) : null;
      } catch (e) {
        console.warn('[StatMed] getService failed', e);
        return null;
      }
    },

    async getAvailability({ locationId, serviceId, daysAhead = 21 }) {
      await ready();
      if (state.mock || !state.db) return mockSlotsFor(locationId, serviceId, daysAhead);
      const ref = state.db
        .collection('locations').doc(locationId)
        .collection('services').doc(serviceId)
        .collection('availability');
      const now = new Date(); now.setHours(0,0,0,0);
      const until = new Date(now.getTime() + daysAhead * 86400000);
      const snap = await ref.where('date', '>=', now.toISOString().slice(0,10))
                            .where('date', '<=', until.toISOString().slice(0,10))
                            .orderBy('date').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },

    async uploadProof(file, { customerEmail, productId }) {
      await ready();
      if (state.mock || !state.storage) {
        // In mock mode, we return a fake ref so the UI can continue.
        return { path: 'mock/proofs/' + (productId || 'x') + '/' + encodeURIComponent(file.name), url: '' };
      }
      const safe = (customerEmail || 'anon').replace(/[^a-z0-9@._-]/gi, '_');
      const key = Date.now() + '-' + file.name.replace(/\s+/g, '_');
      const ref = state.storage.ref().child(`proofs/${safe}/${productId || 'x'}/${key}`);
      const snap = await ref.put(file);
      // getDownloadURL requires READ, which is staff-only on proofs/. Public
      // customers can write but not read, so this would throw for them and
      // make a successful upload look failed. Best-effort only — staff resolve
      // the URL from the stored path later (getProofUrl).
      let url = '';
      try { url = await snap.ref.getDownloadURL(); } catch (e) { /* customer can't read; path is enough */ }
      return { path: snap.ref.fullPath, url };
    },

    // Staff-side: turn a stored proof path into a viewable download URL.
    async getProofUrl(path) {
      await ready();
      if (!path || state.mock || !state.storage) return '';
      try { return await state.storage.ref(path).getDownloadURL(); }
      catch (e) { console.warn('[StatMed] getProofUrl failed', e); return ''; }
    },

    async createBookingDraft(data) {
      await ready();
      // Creates a pending booking record that is later linked to a Shopify
      // order via line item properties + webhook. Returns a short id we can
      // attach to the cart item as a property.
      const payload = Object.assign({
        createdAt: new Date().toISOString(),
        status: 'pending'
      }, data);
      if (state.mock || !state.db) {
        const id = 'draft_' + Math.random().toString(36).slice(2, 10);
        try {
          sessionStorage.setItem('statmed:draft:' + id, JSON.stringify(payload));
        } catch (e) { /* ignore */ }
        return { id, mock: true };
      }
      const doc = await state.db.collection('bookingDrafts').add(payload);
      return { id: doc.id };
    },

    /* ----- v2 Booking (Firestore-native, for sm-booking multi-step) ----- */
    async getScheduleSettings() {
      await ready();
      const fallback = { defaultDays: [1,2,3,4,5,6], defaultSlots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'] };
      if (state.mock || !state.db) return fallback;
      try {
        const doc = await state.db.collection('settings').doc('schedule').get();
        return doc.exists ? doc.data() : fallback;
      } catch (e) { return fallback; }
    },

    // Analytics dashboard config: monthly targets + manually-entered visits.
    // Shape: {
    //   grossTargetMonthly: number,
    //   locationTargetsMonthly: { "Lake City": n, ... },   // keyed by the
    //       exact "Location" line-item value Shopify orders carry
    //   productTargetsMonthly: { "BLS": n, ... },           // keyed by product title
    //   visitsByMonth: { "2026-07": 5020, ... }             // manual website visits
    // } — all monthly; the dashboard derives week/quarter/year.
    async adminGetAnalyticsConfig() {
      await ready();
      const fallback = { grossTargetMonthly: 0, locationTargetsMonthly: {}, productTargetsMonthly: {}, visitsByMonth: {} };
      if (state.mock || !state.db) return fallback;
      try {
        const doc = await state.db.collection('settings').doc('analytics').get();
        return doc.exists ? Object.assign(fallback, doc.data()) : fallback;
      } catch (e) { console.warn('[StatMed] analytics config read failed', e); return fallback; }
    },
    async adminSaveAnalyticsConfig(data) {
      await ready();
      if (state.mock || !state.db) return { ok: true, mock: true };
      await state.db.collection('settings').doc('analytics').set(data || {}, { merge: true });
      return { ok: true };
    },

    // Manually-entered marketing metrics (funnel + ad performance). Stored in
    // admin_metrics/marketing — staff-only via the catch-all rule (ad spend
    // etc. must not be public like settings/* is).
    async adminGetManualMetrics() {
      await ready();
      if (state.mock || !state.db) return null;
      try { const doc = await state.db.collection('admin_metrics').doc('marketing').get(); return doc.exists ? doc.data() : null; }
      catch (e) { console.warn('[StatMed] manual metrics read failed', e); return null; }
    },
    async adminSaveManualMetrics(data) {
      await ready();
      if (state.mock || !state.db) return { ok: true, mock: true };
      await state.db.collection('admin_metrics').doc('marketing').set(data || {});
      return { ok: true };
    },

    /* ---------- Business (B2B) accounts ---------- */
    // businesses/{id}: name, address, contact*, adminEmail, active, plus
    //   officeRates{serviceId: perSeat}, onsiteRates{serviceId:{5,10,15,20,30,50 → perPerson}}
    // businesses/{id}/employees/{empId}: firstName,lastName,email,phone,employeeId,position
    async adminListBusinesses() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('businesses').orderBy('name').get();
      const rows = [];
      snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      return rows;
    },
    async adminGetBusiness(id) {
      await ready();
      if (state.mock || !state.db || !id) return null;
      const doc = await state.db.collection('businesses').doc(id).get();
      return doc.exists ? Object.assign({ id: doc.id }, doc.data()) : null;
    },
    async adminSaveBusiness(id, data) {
      await ready();
      const payload = Object.assign({}, data);
      if (state.mock || !state.db) return { id: id || ('biz_' + Math.random().toString(36).slice(2, 9)), mock: true };
      if (id) {
        // update() replaces each top-level field it names, so a rate the
        // editor left blank (absent from officeRates/onsiteRates) is really
        // removed. set(..., {merge:true}) deep-merged the maps and kept it.
        const ref = state.db.collection('businesses').doc(id);
        try { await ref.update(payload); }
        catch (e) { if (/not-found|no document/i.test((e && (e.code + ' ' + e.message)) || '')) await ref.set(payload); else throw e; }
        return { id };
      }
      payload.createdAt = new Date().toISOString();
      const ref = await state.db.collection('businesses').add(payload);
      return { id: ref.id };
    },
    // Deletes the business AND its employees, certifications and
    // registrations (Firestore does not cascade; leftover employee PII was
    // unreachable from the UI).
    async adminDeleteBusiness(id) {
      await ready();
      if (state.mock || !state.db || !id) return { ok: true };
      const ref = state.db.collection('businesses').doc(id);
      for (const sub of ['employees', 'certifications', 'registrations']) {
        const snap = await ref.collection(sub).get();
        const docs = []; snap.forEach((d) => docs.push(d.ref));
        for (let i = 0; i < docs.length; i += 400) {
          const b = state.db.batch(); docs.slice(i, i + 400).forEach((r) => b.delete(r)); await b.commit();
        }
      }
      await ref.delete();
      return { ok: true };
    },
    // NOTE: named *BizEmployee* on purpose — the internal staff portal already
    // defines adminListEmployees/adminSaveEmployee/adminDeleteEmployee for the
    // top-level `employees` collection. Reusing those names silently shadowed
    // these (last definition wins), so business employees were read/written to
    // the wrong collection.
    async adminListBizEmployees(bizId) {
      await ready();
      if (state.mock || !state.db || !bizId) return [];
      const snap = await state.db.collection('businesses').doc(bizId).collection('employees').get();
      const rows = [];
      snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      rows.sort((a, b) => ((a.lastName || '') + (a.firstName || '')).localeCompare((b.lastName || '') + (b.firstName || '')));
      return rows;
    },
    async adminSaveBizEmployee(bizId, empId, data) {
      await ready();
      const payload = Object.assign({}, data);
      if (state.mock || !state.db) return { id: empId || ('emp_' + Math.random().toString(36).slice(2, 9)), mock: true };
      const col = state.db.collection('businesses').doc(bizId).collection('employees');
      if (empId) { await col.doc(empId).set(payload, { merge: true }); return { id: empId }; }
      payload.createdAt = new Date().toISOString();
      const ref = await col.add(payload);
      return { id: ref.id };
    },
    async adminDeleteBizEmployee(bizId, empId) {
      await ready();
      if (state.mock || !state.db || !bizId || !empId) return { ok: true };
      await state.db.collection('businesses').doc(bizId).collection('employees').doc(empId).delete();
      return { ok: true };
    },

    // Certifications: businesses/{id}/certifications/{id}
    //   { employeeId, employeeName, course, completedDate, renewalDate, source }
    async adminListCertifications(bizId) {
      await ready();
      if (state.mock || !state.db || !bizId) return [];
      const snap = await state.db.collection('businesses').doc(bizId).collection('certifications').get();
      const rows = []; snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      rows.sort((a, b) => (a.renewalDate || '').localeCompare(b.renewalDate || ''));
      return rows;
    },
    async adminSaveCertification(bizId, certId, data) {
      await ready();
      const payload = Object.assign({}, data);
      if (state.mock || !state.db) return { id: certId || ('cert_' + Math.random().toString(36).slice(2, 9)), mock: true };
      const col = state.db.collection('businesses').doc(bizId).collection('certifications');
      if (certId) { await col.doc(certId).set(payload, { merge: true }); return { id: certId }; }
      payload.createdAt = new Date().toISOString();
      const ref = await col.add(payload); return { id: ref.id };
    },
    async adminDeleteCertification(bizId, certId) {
      await ready();
      if (state.mock || !state.db || !bizId || !certId) return { ok: true };
      await state.db.collection('businesses').doc(bizId).collection('certifications').doc(certId).delete();
      return { ok: true };
    },

    // ── Student certifications (top-level `certifications`) ──────────────
    // Powers the renewal-reminder system. Each doc:
    //   { firstName, lastName, email, phone, course, issueDate, expiresDate,
    //     location, channels, source, active, optOut,
    //     reminder7SentAt, reminder30SentAt, reminder90SentAt }
    // expiresDate is always stored (issueDate + 2 years if not given) so the
    // Cloud Function can range-scan it cheaply.
    //
    // Add exactly two years to a YYYY-MM-DD date → YYYY-MM-DD.
    _plus2y(ymd) {
      const m = String(ymd || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return '';
      // Feb 29 + 2y clamps to Feb 28 instead of rolling into March.
      const last = new Date(Date.UTC(+m[1] + 2, +m[2], 0, 12)).getUTCDate();
      return (+m[1] + 2) + '-' + m[2] + '-' + String(Math.min(+m[3], last)).padStart(2, '0');
    },
    // Roster dates → 'YYYY-MM-DD'. Accepts ISO, US (M/D/YYYY, MM/DD/YY) and
    // "Mar 4, 2026". Returns '' for blank, null when it isn't a real date
    // (a non-ISO expiresDate never matches the reminder range query).
    _normDate(v) {
      const s = String(v == null ? '' : v).trim();
      if (!s) return '';
      const MON = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
      let y, mo, d, m;
      if ((m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})(?:[T\s].*)?$/))) { y = +m[1]; mo = +m[2]; d = +m[3]; }
      else if ((m = s.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{2}|\d{4})(?:\s.*)?$/))) { mo = +m[1]; d = +m[2]; y = +m[3]; if (m[3].length === 2) y += y >= 70 ? 1900 : 2000; }
      else if ((m = s.match(/^([A-Za-z]{3,9})\.?\s+(\d{1,2}),?\s+(\d{4})$/))) { mo = MON.indexOf(m[1].slice(0, 3).toLowerCase()) + 1; d = +m[2]; y = +m[3]; }
      else return null;
      if (!(y >= 1950 && y <= 2150) || !(mo >= 1 && mo <= 12) || !(d >= 1) || d > new Date(Date.UTC(y, mo, 0, 12)).getUTCDate()) return null;
      return y + '-' + String(mo).padStart(2, '0') + '-' + String(d).padStart(2, '0');
    },
    // Dedupe identity: same email OR same phone, + same course + same expiry.
    _certKeys(c) {
      const out = []; const tail = '|' + String(c.course || '').toLowerCase().replace(/[^a-z0-9+]+/g, ' ').trim() + '|' + (c.expiresDate || '');
      if (c.email) out.push('e:' + String(c.email).trim().toLowerCase() + tail);
      let p = String(c.phone || '').replace(/\D+/g, ''); if (p.length === 11 && p[0] === '1') p = p.slice(1);
      if (p.length >= 7) out.push('p:' + p + tail);
      return out;
    },
    _certTodayET() {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    },
    // Existing certs (keyed by _certKeys) whose expiresDate is in `dates`.
    async _certExistingKeys(dates) {
      const keys = new Map();
      const uniq = Array.from(new Set((dates || []).filter(Boolean)));
      for (let i = 0; i < uniq.length; i += 10) {
        const snap = await state.db.collection('certifications').where('expiresDate', 'in', uniq.slice(i, i + 10)).get();
        snap.forEach((d) => { const c = Object.assign({ id: d.id }, d.data()); this._certKeys(c).forEach((k) => keys.set(k, c)); });
      }
      return keys;
    },
    // Normalize a raw cert object into the stored shape. Fills expiresDate
    // from issueDate when missing, defaults channels/active. Throws on a
    // date that isn't a real date.
    _certPayload(data) {
      const d = data || {};
      const issueDate = this._normDate(d.issueDate);
      const exp0 = this._normDate(d.expiresDate);
      if (issueDate === null) throw new Error('Issue date "' + d.issueDate + '" isn\'t a date (use M/D/YYYY or YYYY-MM-DD).');
      if (exp0 === null) throw new Error('Expiration date "' + d.expiresDate + '" isn\'t a date (use M/D/YYYY or YYYY-MM-DD).');
      let expiresDate = exp0;
      if (!expiresDate && issueDate) expiresDate = this._plus2y(issueDate);
      const ch = String(d.channels || 'both').toLowerCase();
      return {
        firstName: (d.firstName || '').trim(),
        lastName: (d.lastName || '').trim(),
        email: (d.email || '').trim().toLowerCase(),
        phone: (d.phone || '').trim(),
        course: (d.course || '').trim(),
        issueDate: issueDate,
        expiresDate: expiresDate,
        location: (d.location || '').trim(),
        channels: (ch === 'email' || ch === 'sms') ? ch : 'both',
        source: (d.source || 'manual').trim(),
        active: d.active === false ? false : true,
        optOut: d.optOut === true
      };
    },
    // Default (no expiringWithinDays): soonest-expiring first FROM TODAY,
    // plus the most recently expired — never "the N oldest", which pushed
    // upcoming renewals off the list once the collection grew.
    async adminListCerts({ limit, expiringWithinDays, expiredLimit } = {}) {
      await ready();
      if (state.mock || !state.db) return [];
      const col = state.db.collection('certifications');
      const t0 = this._certTodayET();
      const rows = [];
      if (expiringWithinDays) {
        const hz = new Date(Date.UTC(+t0.slice(0, 4), +t0.slice(5, 7) - 1, +t0.slice(8, 10) + expiringWithinDays, 12)).toISOString().slice(0, 10);
        const snap = await col.where('expiresDate', '>=', t0).where('expiresDate', '<=', hz).orderBy('expiresDate', 'asc').limit(limit || 1000).get();
        snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      } else {
        const [up, ex] = await Promise.all([
          col.where('expiresDate', '>=', t0).orderBy('expiresDate', 'asc').limit(limit || 1000).get(),
          col.where('expiresDate', '<', t0).orderBy('expiresDate', 'desc').limit(expiredLimit || 300).get()
        ]);
        up.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
        ex.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      }
      rows.sort((a, b) => (a.expiresDate || '').localeCompare(b.expiresDate || ''));
      return rows;
    },
    async adminSaveCert(certId, data) {
      await ready();
      const payload = this._certPayload(data);
      if (!payload.expiresDate) throw new Error('A certification needs an issue date or an expiration date.');
      if (state.mock || !state.db) return { id: certId || ('cert_' + Math.random().toString(36).slice(2, 9)), ...payload, mock: true };
      const col = state.db.collection('certifications');
      const FV = window.firebase.firestore.FieldValue;
      payload.updatedAt = new Date().toISOString();
      if (certId) {
        const cur = await col.doc(certId).get();
        const write = Object.assign({}, payload);
        // Card renewed / expiry changed: clear the sent stamps so the
        // certificationReminder function sends the next cycle.
        if (cur.exists && (cur.data().expiresDate || '') !== payload.expiresDate) {
          write.reminder90SentAt = FV.delete(); write.reminder30SentAt = FV.delete(); write.reminder7SentAt = FV.delete(); write.lastRenewalReminder = FV.delete();
        }
        await col.doc(certId).set(write, { merge: true });
        return { id: certId, ...payload };
      }
      // Same person + course + expiry already on file → update it instead of
      // creating a duplicate (duplicates mean double reminders).
      const existing = await this._certExistingKeys([payload.expiresDate]);
      const dup = this._certKeys(payload).map((k) => existing.get(k)).find(Boolean);
      if (dup) { await col.doc(dup.id).set(payload, { merge: true }); return { id: dup.id, ...payload, duplicateOf: dup.id }; }
      payload.createdAt = new Date().toISOString();
      const ref = await col.add(payload);
      return { id: ref.id, ...payload };
    },
    async adminDeleteCert(certId) {
      await ready();
      if (state.mock || !state.db || !certId) return { ok: true };
      await state.db.collection('certifications').doc(certId).delete();
      return { ok: true };
    },
    // Bulk import. `rows` is an array of raw cert objects. Writes in batches
    // of 400. Returns { added, skipped, duplicates, errors } — every skipped
    // row has a reason in `errors` ("Row N: …", N = 1-based data row). Rows
    // already on file (same email or phone + course + expiry) or repeated in
    // the same import are skipped, so re-importing a roster is safe.
    async adminImportCerts(rows) {
      await ready();
      const result = { added: 0, skipped: 0, duplicates: 0, errors: [] };
      if (!Array.isArray(rows) || !rows.length) return result;
      const ok = [];
      for (let i = 0; i < rows.length; i++) {
        let p;
        try { p = this._certPayload(rows[i]); } catch (e) { result.skipped++; result.errors.push('Row ' + (i + 1) + ': ' + e.message); continue; }
        if (!p.expiresDate) { result.skipped++; result.errors.push('Row ' + (i + 1) + ': needs an issue date or an expiration date.'); continue; }
        if (!p.email && !p.phone) { result.skipped++; result.errors.push('Row ' + (i + 1) + ': needs an email or a phone number.'); continue; }
        if (!p.course) { result.skipped++; result.errors.push('Row ' + (i + 1) + ': needs a course.'); continue; }
        ok.push({ i, p });
      }
      if (state.mock || !state.db) { result.added = ok.length; return result; }
      const existing = await this._certExistingKeys(ok.map((x) => x.p.expiresDate));
      const seen = new Set();
      const col = state.db.collection('certifications');
      let batch = state.db.batch(); let inBatch = 0;
      for (const { i, p } of ok) {
        const keys = this._certKeys(p);
        if (keys.some((k) => existing.has(k) || seen.has(k))) { result.skipped++; result.duplicates++; result.errors.push('Row ' + (i + 1) + ': already on file (duplicate).'); continue; }
        keys.forEach((k) => seen.add(k));
        p.createdAt = new Date().toISOString();
        p.updatedAt = p.createdAt;
        batch.set(col.doc(), p);
        inBatch++; result.added++;
        if (inBatch >= 400) { await batch.commit(); batch = state.db.batch(); inBatch = 0; }
      }
      if (inBatch > 0) await batch.commit();
      return result;
    },

    // Baseline tracker — a single staff-only doc holding the metric snapshot
    // map (keyed like "sales_total_base"). Stored under app_meta/baseline,
    // which the catch-all rule keeps staff-only.
    async adminGetBaseline() {
      await ready();
      if (state.mock || !state.db) return {};
      try {
        const d = await state.db.collection('app_meta').doc('baseline').get();
        return d.exists ? ((d.data() || {}).data || {}) : {};
      } catch (e) { console.warn('[StatMed] adminGetBaseline failed', e); return {}; }
    },
    async adminSaveBaseline(map) {
      await ready();
      if (state.mock || !state.db) return { ok: true, mock: true };
      await state.db.collection('app_meta').doc('baseline').set({ data: map || {}, updatedAt: new Date().toISOString() });
      return { ok: true };
    },
    async adminListRegistrations(bizId) {
      await ready();
      if (state.mock || !state.db || !bizId) return [];
      const snap = await state.db.collection('businesses').doc(bizId).collection('registrations').get();
      const rows = []; snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      rows.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
      return rows;
    },
    async adminUpdateRegistration(bizId, regId, data) {
      await ready();
      if (state.mock || !state.db || !bizId || !regId) return { ok: true };
      await state.db.collection('businesses').doc(bizId).collection('registrations').doc(regId).set(data || {}, { merge: true });
      return { ok: true };
    },

    /* ---------- Instructor portal ---------- */
    // materials/{id}: name, description, standardPrice, sku, active
    // instructors/{id}: name, email (login), phone, active, pricing{materialId: price}
    async adminListMaterials() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('materials').orderBy('name').get();
      const rows = []; snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      return rows;
    },
    async adminSaveMaterial(id, data) {
      await ready();
      const payload = Object.assign({}, data);
      if (state.mock || !state.db) return { id: id || ('mat_' + Math.random().toString(36).slice(2, 9)), mock: true };
      if (id) { await state.db.collection('materials').doc(id).set(payload, { merge: true }); return { id }; }
      payload.createdAt = new Date().toISOString();
      const ref = await state.db.collection('materials').add(payload); return { id: ref.id };
    },
    async adminDeleteMaterial(id) {
      await ready();
      if (state.mock || !state.db || !id) return { ok: true };
      await state.db.collection('materials').doc(id).delete(); return { ok: true };
    },
    async adminListInstructors() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('instructors').orderBy('name').get();
      const rows = []; snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      return rows;
    },
    async adminGetInstructor(id) {
      await ready();
      if (state.mock || !state.db || !id) return null;
      const doc = await state.db.collection('instructors').doc(id).get();
      return doc.exists ? Object.assign({ id: doc.id }, doc.data()) : null;
    },
    async adminSaveInstructor(id, data) {
      await ready();
      const payload = Object.assign({}, data);
      if (state.mock || !state.db) return { id: id || ('ins_' + Math.random().toString(36).slice(2, 9)), mock: true };
      // mergeFields replaces each given top-level field wholesale, so a
      // pricing map with an item unchecked really drops that item (a plain
      // merge:true deep-merges maps and kept revoked items purchasable).
      if (id) { await state.db.collection('instructors').doc(id).set(payload, { mergeFields: Object.keys(payload) }); return { id }; }
      payload.createdAt = new Date().toISOString();
      const ref = await state.db.collection('instructors').add(payload); return { id: ref.id };
    },
    async adminDeleteInstructor(id) {
      await ready();
      if (state.mock || !state.db || !id) return { ok: true };
      await state.db.collection('instructors').doc(id).delete(); return { ok: true };
    },
    /* ---------- Class portal (one-off class registration + quiz) ---------- */
    async submitClassRegistration(data) {
      await ready();
      const payload = Object.assign({ createdAt: new Date().toISOString() }, data || {});
      if (state.mock || !state.db) return { id: 'reg_' + Math.random().toString(36).slice(2, 9), mock: true };
      const ref = await state.db.collection('class_registrations').add(payload);
      return { id: ref.id };
    },
    async submitClassQuiz(data) {
      await ready();
      const payload = Object.assign({ createdAt: new Date().toISOString() }, data || {});
      if (state.mock || !state.db) return { id: 'quiz_' + Math.random().toString(36).slice(2, 9), mock: true };
      const ref = await state.db.collection('class_quiz_submissions').add(payload);
      return { id: ref.id };
    },
    async adminListClassRegistrations() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('class_registrations').get();
      const rows = []; snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      rows.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
      return rows;
    },
    async adminListClassQuiz() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('class_quiz_submissions').get();
      const rows = []; snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      rows.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''));
      return rows;
    },

    // Instructor-facing: the instructor whose login email matches, + checkout.
    async getMyInstructor() {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user || !user.email || state.mock || !state.db) return null;
      const snap = await state.db.collection('instructors').where('email', '==', user.email.toLowerCase()).limit(1).get();
      if (snap.empty) return null;
      const d = snap.docs[0]; return Object.assign({ id: d.id }, d.data());
    },
    async instructorCheckout(payload) {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in first');
      const idToken = await user.getIdToken(false);
      let url = (window.StatMedConfig && window.StatMedConfig.instructorCheckoutUrl) || '';
      if (!url) { const a = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || ''; url = a.replace(/\/analytics\/?$/, '/instructorCheckout'); }
      if (!url) throw new Error('Checkout is not configured yet.');
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken }, body: JSON.stringify(payload || {}) });
      const body = await res.json().catch(() => ({ error: 'Invalid response' }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    },

    async getLocationsForService(serviceId) {
      await ready();
      if (state.mock || !state.db) {
        return FALLBACK_LOCATIONS.map((l) => Object.assign({ services: [serviceId], openDays: [1,2,3,4,5,6], slots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'] }, l));
      }
      const snap = await state.db.collection('locations').where('active','==',true).get();
      const out = [];
      snap.forEach((d) => {
        const data = Object.assign({ id: d.id }, d.data());
        if (!serviceId || !data.services || data.services.indexOf(serviceId) > -1) out.push(data);
      });
      return out;
    },

    // Fetch a single location by ID, no service filter. Used on per-location
    // booking pages (force_location set) where the merchant has already
    // declared the combo valid — we trust them rather than re-checking the
    // location's services array.
    async getLocationById(locationId) {
      await ready();
      if (!locationId) return null;
      if (state.mock || !state.db) {
        const m = FALLBACK_LOCATIONS.find((l) => l.id === locationId);
        return m ? Object.assign({ openDays: [1,2,3,4,5,6], slots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'] }, m) : null;
      }
      const doc = await state.db.collection('locations').doc(locationId).get();
      return doc.exists ? Object.assign({ id: doc.id }, doc.data()) : null;
    },

    /* ----- Availability blocks (blocked_dates / blocked_times) -----
       Who a block applies to. A block doc may carry any of:
         services[]        exact service ids (written expanded per office)
         resourceGroups[]  service resource groups (e.g. "front-desk")
         families[]        course families ("bls", "background-check", ...)
         formats[]         optional format filter for families[] ("skills-only")
         scope             new admin: 'all' | 'cpr' | 'fingerprint' | 'courses' | 'classroom'
         adminOnly         legacy: staff-only block (ignored for customers)
       All three lists empty = the whole office is closed. Otherwise the block
       applies when ANY list matches the booking's service. A doc that says
       it is scoped (scope !== 'all') but lists nothing never closes the
       whole office. */
    blockFamilyOf(id) {
      const s = String(id == null ? '' : id).toLowerCase();
      const w = (k) => new RegExp('(^|[^a-z])' + k + '([^a-z]|$)').test(s);
      const bls = w('bls') || /basic-life/.test(s), acls = w('acls'), pals = w('pals');
      if (bls && acls && pals) return 'bls-acls-pals';
      if (bls && acls) return 'bls-acls';
      if (bls && pals) return 'bls-pals';
      if (acls && pals) return 'acls-pals';
      if (acls) return 'acls';
      if (pals) return 'pals';
      if (bls) return 'bls';
      if (/heart-?saver/.test(s)) return /pediatric/.test(s) ? 'heartsaver-pediatric' : 'heartsaver';
      if (/background|fingerprint|level-?2/.test(s)) return 'background-check';
      if (w('cna') || /nursing-assistant/.test(s)) return 'cna';
      if (w('iv')) return 'iv';
      if (w('apd')) return 'apd';
      if (/until-help/.test(s)) return 'until-help-arrives';
      if (w('cpr')) return 'cpr';
      return '';
    },
    blockFormatOf(id) {
      const s = String(id == null ? '' : id).toLowerCase();
      if (/skills-?only/.test(s)) return 'skills-only';
      if (/self-?guided|heartcode/.test(s)) return 'self-guided';
      if (/blended/.test(s)) return 'blended';
      if (/renewal/.test(s)) return 'renewal';
      if (/exam-?only/.test(s)) return 'exam-only';
      if (/in-?person|classroom/.test(s)) return 'in-person';
      return '';
    },
    // Build the matching context for one booking surface. serviceIds lets a
    // caller match several ids (e.g. the fingerprint form passes its
    // per-office id and the "background-check" family id).
    _blockCtx({ serviceId, serviceIds, resourceGroup, family, includeAdminOnly } = {}) {
      const ids = [].concat(serviceIds || [], serviceId || []).filter(Boolean).map(String);
      let fam = family || '';
      let fmt = '';
      for (let i = 0; i < ids.length && !fam; i++) fam = this.blockFamilyOf(ids[i]);
      for (let i = 0; i < ids.length && !fmt; i++) fmt = this.blockFormatOf(ids[i]);
      return { serviceIds: ids, resourceGroup: resourceGroup || '', family: fam, format: fmt, includeAdminOnly: !!includeAdminOnly };
    },
    _blockApplies(doc, ctx) {
      if (!doc) return false;
      ctx = ctx || this._blockCtx({});
      // Legacy "admin-only" blocks only stop staff class scheduling; customers ignore them.
      if (doc.adminOnly && !ctx.includeAdminOnly) return false;
      const list = (v) => (Array.isArray(v) ? v.filter(Boolean).map(String) : []);
      const svcs = list(doc.services), groups = list(doc.resourceGroups), fams = list(doc.families), fmts = list(doc.formats);
      if (!svcs.length && !groups.length && !fams.length) return !doc.scope || doc.scope === 'all';
      if (svcs.length && ctx.serviceIds.some((id) => svcs.indexOf(id) !== -1)) return true;
      if (groups.length && ctx.resourceGroup && groups.indexOf(ctx.resourceGroup) !== -1) return true;
      if (fams.length && ctx.family && fams.indexOf(ctx.family) !== -1 &&
          (!fmts.length || (ctx.format && fmts.indexOf(ctx.format) !== -1))) return true;
      return false;
    },
    // If any block is scoped by resource group and the caller didn't say
    // which group its service is in, look it up from the services doc.
    async _blockCtxResolved(opts, docs) {
      const ctx = this._blockCtx(opts);
      const needsGroup = !ctx.resourceGroup && ctx.serviceIds.length &&
        (docs || []).some((d) => Array.isArray(d.resourceGroups) && d.resourceGroups.length);
      if (needsGroup) {
        this._svcGroupCache = this._svcGroupCache || {};
        for (const id of ctx.serviceIds) {
          if (!(id in this._svcGroupCache)) {
            const svc = await this.getService(id);
            this._svcGroupCache[id] = (svc && svc.resourceGroup) || '';
          }
          if (this._svcGroupCache[id]) { ctx.resourceGroup = this._svcGroupCache[id]; break; }
        }
      }
      return ctx;
    },
    _todayNY(offsetDays) {
      const dt = new Date(Date.now() + (offsetDays || 0) * 86400000);
      return dt.toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
    },
    // Pure: blocked_dates docs -> { 'YYYY-MM-DD': true } for one context.
    _blockedDatesFromDocs(docs, ctx) {
      const blocked = {};
      const ymd = (dt) => dt.getUTCFullYear() + '-' + String(dt.getUTCMonth() + 1).padStart(2, '0') + '-' + String(dt.getUTCDate()).padStart(2, '0');
      const parse = (s) => { const m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12)) : null; };
      (docs || []).forEach((data) => {
        if (!this._blockApplies(data, ctx)) return;
        // Range stored as startDate/endDate; legacy single-day docs used `date`.
        let a = parse(data.startDate || data.date);
        let b = parse(data.endDate || data.startDate || data.date);
        if (!a) return;
        if (!b) b = a;
        if (b < a) { const t = a; a = b; b = t; } // typo'd reversed range: block the span, not nothing
        for (let i = 0; a <= b && i < 732; i++) { blocked[ymd(a)] = true; a.setUTCDate(a.getUTCDate() + 1); }
      });
      return blocked;
    },
    // Pure: blocked_times docs for one date -> [{ id, startMin, endMin, reason }].
    _blockedTimesFromDocs(docs, date, ctx) {
      const out = [];
      (docs || []).forEach((x) => {
        if (!x || x.date !== date) return;
        if (typeof x.startMinutes !== 'number' || typeof x.endMinutes !== 'number' || x.endMinutes <= x.startMinutes) return;
        if (!this._blockApplies(x, ctx)) return;
        out.push({ id: x.id, startMin: x.startMinutes, endMin: x.endMinutes, reason: x.reason || '' });
      });
      return out;
    },

    // Public read. Options: { locationId, serviceId, resourceGroup?, family?,
    // serviceIds?, includeAdminOnly? } -> { 'YYYY-MM-DD': true }.
    // Only blocks that end yesterday-or-later are read (two single-field
    // range queries, no composite index); falls back to the old
    // per-location query if those fail.
    async getBlockedDates({ locationId, serviceId, resourceGroup, family, serviceIds, includeAdminOnly } = {}) {
      await ready();
      if (state.mock || !state.db || !locationId) return {};
      const cutoff = this._todayNY(-1);
      const byId = {};
      const take = (snap) => snap.forEach((d) => { const x = d.data() || {}; if (x.location === locationId) byId[d.id] = Object.assign({ id: d.id }, x); });
      // One query by office (as before). A bounded endDate/date range query
      // would silently skip docs missing those fields (e.g. hand-entered docs
      // with only startDate), letting customers book a closed day.
      take(await state.db.collection('blocked_dates').where('location', '==', locationId).get());
      void cutoff;
      const docs = Object.keys(byId).map((k) => byId[k]);
      const ctx = await this._blockCtxResolved({ serviceId, serviceIds, resourceGroup, family, includeAdminOnly }, docs);
      return this._blockedDatesFromDocs(docs, ctx);
    },

    // Compute the slot_counters doc key for a (location, service, group)
    // tuple. The key determines which counter doc bookings share.
    //   - Cross-location group → just the group ID
    //   - Per-location group   → "<location>__<group>"
    //   - No group             → "<location>__<service>"
    // The actual doc ID adds "__<date>" so a counter doc holds an entire
    // day's slot map: { slots: { "9:00 AM": 3, "10:00 AM": 1, ... } }
    _slotCounterKey({ locationId, serviceId, resourceGroup, crossLocations }) {
      if (resourceGroup && crossLocations) return String(resourceGroup);
      if (resourceGroup) return String(locationId) + '__' + String(resourceGroup);
      return String(locationId) + '__' + String(serviceId);
    },

    // How long a soft hold lasts before the seat is freed again (ms).
    _holdMs() { return 15 * 60 * 1000; },

    // Track the holds THIS browser created so the visitor doesn't see their
    // own in-cart reservation as "taken" when they return to the page, and
    // so re-selecting their slot reuses the hold instead of being blocked.
    _ownHolds() {
      try {
        const raw = window.localStorage.getItem('sm_own_holds');
        const arr = raw ? JSON.parse(raw) : [];
        const now = Date.now();
        const live = arr.filter((h) => h && h.id && Number(h.exp) > now);
        if (live.length !== arr.length) window.localStorage.setItem('sm_own_holds', JSON.stringify(live));
        return live;
      } catch (e) { return []; }
    },
    _ownHoldIds() { return new Set(this._ownHolds().map((h) => h.id)); },
    _recordOwnHold(id, exp) {
      if (!id) return;
      try {
        const arr = this._ownHolds();
        const i = arr.findIndex((h) => h.id === id);
        if (i >= 0) arr[i].exp = exp; else arr.push({ id, exp });
        window.localStorage.setItem('sm_own_holds', JSON.stringify(arr));
      } catch (e) {}
    },

    // Count the live reservations for one time slot from a slot_counters
    // doc: permanent `confirmed` bookings + non-expired `holds`.
    _validCountForTime(data, time, now, ownHoldIds) {
      if (!data) return 0;
      const confirmed = (data.confirmed && data.confirmed[time]) || 0;
      const holdsForTime = (data.holds && data.holds[time]) || {};
      let live = 0;
      Object.keys(holdsForTime).forEach((hid) => {
        if (ownHoldIds && ownHoldIds.has(hid)) return; // don't count my own hold against me
        if (Number(holdsForTime[hid]) > now) live++;
      });
      return confirmed + live;
    },

    async getBookedSlots({ locationId, serviceId, resourceGroup, crossLocations, date } = {}) {
      await ready();
      if (state.mock || !state.db) return {};
      if (!date) return {};
      // Public read of the slot_counters doc (no PII). Returns a
      // { time: takenCount } map where takenCount = confirmed bookings +
      // holds that haven't expired yet, so abandoned holds free up
      // automatically once their 15-minute window lapses.
      const key = this._slotCounterKey({ locationId, serviceId, resourceGroup, crossLocations });
      const docId = key + '__' + date;
      try {
        const snap = await state.db.collection('slot_counters').doc(docId).get();
        if (!snap.exists) return {};
        const data = snap.data() || {};
        const now = Date.now();
        const own = this._ownHoldIds();
        const out = {};
        // Union of all times that appear in confirmed or holds.
        const times = {};
        Object.keys(data.confirmed || {}).forEach((t) => { times[t] = 1; });
        Object.keys(data.holds || {}).forEach((t) => { times[t] = 1; });
        // Back-compat: older docs used a flat `slots` integer map.
        if (data.slots) Object.keys(data.slots).forEach((t) => { out[t] = data.slots[t]; });
        Object.keys(times).forEach((t) => { out[t] = this._validCountForTime(data, t, now, own); });
        return out;
      } catch (e) {
        console.warn('[StatMed] getBookedSlots failed', e);
        return {};
      }
    },

    async getServicesInGroup(resourceGroup) {
      await ready();
      if (!resourceGroup || state.mock || !state.db) return [];
      const snap = await state.db.collection('services')
        .where('resourceGroup','==', resourceGroup)
        .get();
      const out = [];
      snap.forEach((d) => out.push(d.id));
      return out;
    },

    // Read a single resource_group doc — used to find out whether the
    // group is shared across locations (sharedAcrossLocations: true).
    async getResourceGroup(id) {
      await ready();
      if (!id || state.mock || !state.db) return null;
      try {
        const snap = await state.db.collection('resource_groups').doc(id).get();
        return snap.exists ? Object.assign({ id: snap.id }, snap.data()) : null;
      } catch (e) {
        console.warn('[StatMed] getResourceGroup failed', e);
        return null;
      }
    },

    // Convert a held booking to a permanent confirmed seat. Called by the
    // orders/paid webhook (step B). Moves the seat from holds → confirmed
    // so it no longer expires.
    async confirmBooking(bookingId) {
      await ready();
      if (!bookingId || state.mock || !state.db) return { ok: false };
      const bookingRef = state.db.collection('bookings').doc(bookingId);
      const FV = window.firebase.firestore.FieldValue;
      return state.db.runTransaction(async (tx) => {
        const bSnap = await tx.get(bookingRef);
        if (!bSnap.exists) return { ok: false, reason: 'not_found' };
        const b = bSnap.data() || {};
        if (b.status === 'confirmed') return { ok: true, already: true };
        const counterRef = state.db.collection('slot_counters').doc(b.counterId);
        const cSnap = await tx.get(counterRef);
        const data = cSnap.exists ? (cSnap.data() || {}) : {};
        const holds = data.holds || {};
        const holdsForTime = holds[b.time] || {};
        delete holdsForTime[bookingId];
        const update = {};
        update['holds.' + b.time] = holdsForTime;
        update['confirmed.' + b.time] = FV.increment(1);
        if (cSnap.exists) tx.update(counterRef, update);
        else tx.set(counterRef, { confirmed: { [b.time]: 1 }, holds: {}, counterKey: data.counterKey || '', date: b.date });
        tx.update(bookingRef, { status: 'confirmed', confirmedAt: FV.serverTimestamp() });
        return { ok: true };
      });
    },

    async createBookingAtomic({ locationId, serviceId, resourceGroup, crossLocations, date, time, maxPerSlot, bookingData, holdMinutes, ownHoldIds }) {
      await ready();
      if (state.mock || !state.db) {
        const id = 'bk_' + Math.random().toString(36).slice(2,10);
        this._recordOwnHold(id, Date.now() + this._holdMs());
        return { id, mock: true, holdExpiresAt: Date.now() + this._holdMs() };
      }
      const own = (ownHoldIds instanceof Set) ? ownHoldIds : new Set(ownHoldIds || this._ownHoldIds());
      // Creates a soft HOLD (not a permanent booking). One transaction:
      //   1. Read the slot_counters doc
      //   2. Prune holds whose 15-min window already expired
      //   3. Count confirmed + live holds; throw SLOT_FULL if at capacity
      //   4. Add this hold (keyed by the booking id) with an expiry
      //   5. Write the booking doc with status:'held' + holdExpiresAt
      // A later orders/paid webhook calls confirmBooking() to make it
      // permanent; if the customer never checks out, the hold lapses and
      // getBookedSlots stops counting it.
      const key = this._slotCounterKey({ locationId, serviceId, resourceGroup, crossLocations });
      const counterId = key + '__' + date;
      const counterRef = state.db.collection('slot_counters').doc(counterId);
      const bookingsCol = state.db.collection('bookings');
      const FV = window.firebase.firestore.FieldValue;
      const now = Date.now();
      const holdMs = (holdMinutes ? holdMinutes * 60 * 1000 : this._holdMs());
      const expiresAt = now + holdMs;
      let resultId = null;
      await state.db.runTransaction(async (tx) => {
        const cSnap = await tx.get(counterRef);
        const data = cSnap.exists ? (cSnap.data() || {}) : {};
        // Migrate legacy flat `slots` integer into confirmed on first touch.
        if (data.slots && !data.confirmed) {
          data.confirmed = Object.assign({}, data.slots);
        }
        const holdsForTime = Object.assign({}, (data.holds && data.holds[time]) || {});
        // Prune expired holds.
        Object.keys(holdsForTime).forEach((hid) => { if (Number(holdsForTime[hid]) <= now) delete holdsForTime[hid]; });
        // If this visitor already holds this exact slot, reuse that hold
        // (refresh its expiry) instead of creating a second one.
        let mineId = null;
        Object.keys(holdsForTime).forEach((hid) => { if (own.has(hid)) mineId = hid; });
        // Count taken seats, excluding this visitor's own holds so their own
        // in-cart reservation never blocks them from re-selecting it.
        const confirmed = (data.confirmed && data.confirmed[time]) || 0;
        let liveOthers = 0;
        Object.keys(holdsForTime).forEach((hid) => { if (!own.has(hid) && Number(holdsForTime[hid]) > now) liveOthers++; });
        if (!mineId && (confirmed + liveOthers) >= maxPerSlot) {
          const e = new Error('SLOT_FULL'); e.code = 'SLOT_FULL'; throw e;
        }
        const bookingRef = mineId ? bookingsCol.doc(mineId) : bookingsCol.doc();
        holdsForTime[bookingRef.id] = expiresAt;
        if (cSnap.exists) {
          const update = {};
          update['holds.' + time] = holdsForTime;
          if (data.slots && !cSnap.data().confirmed) update.confirmed = data.confirmed;
          tx.update(counterRef, update);
        } else {
          tx.set(counterRef, { counterKey: key, date, confirmed: {}, holds: { [time]: holdsForTime }, createdAt: FV.serverTimestamp() });
        }
        // Only write the booking doc for a brand-new hold. Reusing an existing
        // hold just refreshed its expiry in slot_counters above; rewriting the
        // booking doc would be an UPDATE, which is staff-only under the rules.
        if (!mineId) {
          tx.set(bookingRef, Object.assign({}, bookingData, {
            id: bookingRef.id,
            location: locationId,
            service: serviceId,
            resourceGroup: resourceGroup || null,
            date,
            time,
            counterId,
            status: 'held',
            holdExpiresAt: expiresAt,
            createdAt: FV.serverTimestamp()
          }));
        }
        resultId = bookingRef.id;
      });
      this._recordOwnHold(resultId, expiresAt);
      return { id: resultId, holdExpiresAt: expiresAt };
    },

    /* ----- Admin (Firebase Auth gated) ----- */
    async signIn(email, password) {
      await ready();
      if (state.mock || !state.auth) return { uid: 'mock-user', email };
      const cred = await state.auth.signInWithEmailAndPassword(email, password);
      return { uid: cred.user.uid, email: cred.user.email };
    },
    async signOut() {
      if (state.auth) await state.auth.signOut();
    },
    currentUser() {
      return state.auth && state.auth.currentUser;
    },
    // First-time business admins set their own password (their email must
    // already match a business the staff created).
    async businessSignUp(email, password) {
      await ready();
      if (state.mock || !state.auth) return { uid: 'mock-user', email };
      const cred = await state.auth.createUserWithEmailAndPassword(email, password);
      return { uid: cred.user.uid, email: cred.user.email };
    },
    // Fire cb with the current auth user (or null) once, after init + restore.
    onAuth(cb) {
      onReady(() => { if (state.auth) { const off = state.auth.onAuthStateChanged((u) => { off(); cb(u); }); } else cb(null); });
    },
    // Owner-only: list / save the live theme's page text (Backend → Site
    // content). See functions/site-content.js.
    async siteContent(payload) {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in first');
      const idToken = await user.getIdToken(false);
      let url = (window.StatMedConfig && window.StatMedConfig.siteContentUrl) || '';
      if (!url) {
        const a = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || '';
        url = a.replace(/\/analytics\/?$/, '/siteContent');
      }
      if (!url) throw new Error('Site content editor is not configured (Theme settings → Analytics function URL).');
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify(payload || {})
      });
      const body = await res.json().catch(() => ({ error: res.status === 404 ? 'The siteContent function is not deployed yet.' : 'Invalid response' }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    },
    // Create a Shopify draft order at the business's negotiated rate and
    // return its checkout URL. Prices are recomputed server-side.
    async businessCheckout(payload) {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in first');
      const idToken = await user.getIdToken(false);
      let url = (window.StatMedConfig && window.StatMedConfig.businessCheckoutUrl) || '';
      if (!url) {
        const a = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || '';
        url = a.replace(/\/analytics\/?$/, '/businessCheckout');
      }
      if (!url) throw new Error('Checkout is not configured yet.');
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify(payload || {})
      });
      const body = await res.json().catch(() => ({ error: 'Invalid response' }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    },
    // Staff-only: create + email a Shopify invoice for a class student's
    // remaining tuition balance (class price − deposit). Recomputed server-side.
    async classBalanceCheckout(payload) {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in first');
      const idToken = await user.getIdToken(false);
      let url = (window.StatMedConfig && window.StatMedConfig.classBalanceCheckoutUrl) || '';
      if (!url) {
        const a = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || '';
        url = a.replace(/\/analytics\/?$/, '/classBalanceCheckout');
      }
      if (!url) throw new Error('Balance invoicing is not configured yet.');
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify(payload || {})
      });
      const body = await res.json().catch(() => ({ error: 'Invalid response' }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    },
    // Site variables — reusable text/values shown via [[key]] tokens on any
    // page. Public read (no PII); staff write. Stored at settings/site_vars.
    // Built-in defaults live in StatMed.SITE_VAR_DEFAULTS (bottom of file).
    async getSiteVariables() {
      await ready();
      if (state.mock || !state.db) return {};
      try { const snap = await state.db.collection('settings').doc('site_vars').get(); return (snap.exists && (snap.data() || {}).vars) || {}; }
      catch (e) { return {}; }
    },
    async adminSaveSiteVariables(vars) {
      await ready();
      if (state.mock || !state.db) return { ok: true };
      await state.db.collection('settings').doc('site_vars').set({ vars: vars || {} }); // full replace so deletes stick
      return { ok: true };
    },
    // Self-service reschedule (public — booking id is the token).
    async rescheduleLookup(bookingId) {
      await ready();
      let url = (window.StatMedConfig && window.StatMedConfig.rescheduleLookupUrl) || '';
      if (!url) { const a = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || ''; url = a.replace(/\/analytics\/?$/, '/rescheduleLookup'); }
      if (!url) throw new Error('Reschedule is not configured yet.');
      const res = await fetch(url + '?b=' + encodeURIComponent(bookingId), { method: 'GET' });
      const body = await res.json().catch(() => ({ error: 'Invalid response' }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    },
    async rescheduleApply(payload) {
      await ready();
      let url = (window.StatMedConfig && window.StatMedConfig.rescheduleApplyUrl) || '';
      if (!url) { const a = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || ''; url = a.replace(/\/analytics\/?$/, '/rescheduleApply'); }
      if (!url) throw new Error('Reschedule is not configured yet.');
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload || {}) });
      const body = await res.json().catch(() => ({ error: 'Invalid response' }));
      if (!res.ok) { const err = new Error(body.error || ('HTTP ' + res.status)); err.requiresPayment = !!body.requiresPayment; err.fee = body.fee; throw err; }
      return body;
    },
    // The business whose account-admin email (adminEmail, or any entry of
    // adminEmails[]) is the signed-in user's email. The caller must check
    // `active` (inactive accounts get a "paused" screen in the portal).
    async getMyBusiness() {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user || !user.email || state.mock || !state.db) return null;
      const email = user.email.toLowerCase();
      const col = state.db.collection('businesses');
      let snap = await col.where('adminEmail', '==', email).limit(2).get();
      if (snap.empty) {
        try { snap = await col.where('adminEmails', 'array-contains', email).limit(2).get(); }
        catch (e) { console.warn('[StatMed] adminEmails lookup failed', e); return null; }
      }
      if (snap.empty) return null;
      const d = snap.docs[0];
      return Object.assign({ id: d.id, _duplicates: snap.size > 1 }, d.data());
    },
    // Portal: ask Firebase to email a "confirm your email" link to the
    // signed-in user, and re-read the user after they click it.
    async sendEmailVerification() {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (state.mock || !user) return { ok: true, mock: true };
      await user.sendEmailVerification();
      return { ok: true };
    },
    async reloadUser() {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (state.mock || !user) return user || null;
      await user.reload();
      return state.auth.currentUser;
    },
    // Pick the bookable service that represents a B2B course at an office.
    // MUST match b2bPickService() in functions/index.js.
    _b2bPickService(list, course) {
      const c = String(course || '').toLowerCase();
      const PREF = ['in-person', 'classroom', 'blended', 'skills-only', 'self-guided', 'renewal'];
      const ok = (list || []).filter((s) => {
        if (!s || s.active === false) return false;
        const k = String(s.productKey || '').toLowerCase(); const id = String(s.id || '').toLowerCase();
        if (k) return k === c;
        if (c === 'heartsaver' && id.indexOf('heartsaver-pediatric') === 0) return false;
        if (c === 'bls' && /^bls-(acls|pals)/.test(id)) return false;
        return id === c || id.indexOf(c + '-') === 0;
      });
      const rank = (s) => { const t = String(s.styleKey || s.id || '').toLowerCase(); const i = PREF.findIndex((p) => t.indexOf(p) !== -1); return i === -1 ? 99 : i; };
      return ok.sort((a, b) => rank(a) - rank(b) || String(a.id).localeCompare(String(b.id)))[0] || null;
    },
    // Business portal: which times at an office can take a group of
    // `count` people for `course` on `date`. Checks the office's open
    // days, blocked dates and blocked times (incl. service-scoped ones),
    // its own slot list and live slot capacity (slot_counters).
    // Returns { ok, closedReason, serviceId, serviceName, maxPerSlot,
    //           slots: [{ time, left, blocked }] }.
    async businessOfficeAvailability({ course, locationId, date } = {}) {
      await ready();
      const wd = (ymd) => { const p = String(ymd || '').split('-').map(Number); return new Date(Date.UTC(p[0], p[1] - 1, p[2], 12)).getUTCDay(); };
      const DAYS = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
      if (!locationId || !/^\d{4}-\d{2}-\d{2}$/.test(String(date || ''))) return { ok: false, closedReason: '', slots: [] };
      if (state.mock || !state.db) {
        if (wd(date) === 0 || wd(date) === 6) return { ok: false, closedReason: 'That office is closed on ' + DAYS[wd(date)] + '. Please pick a weekday.', slots: [] };
        return { ok: true, mock: true, serviceId: course, serviceName: course, maxPerSlot: 8, slots: ['9:00 AM', '11:00 AM', '1:00 PM', '3:00 PM'].map((t, i) => ({ time: t, left: i === 1 ? 2 : 8, blocked: '' })) };
      }
      const loc = await this.getLocationById(locationId);
      if (!loc || loc.active === false) return { ok: false, closedReason: 'That office isn’t taking bookings right now. Please pick another office.', slots: [] };
      const openDays = Array.isArray(loc.openDays) && loc.openDays.length ? loc.openDays.map(Number) : null;
      if (openDays && openDays.indexOf(wd(date)) === -1) return { ok: false, closedReason: 'That office is closed on ' + DAYS[wd(date)] + '. Please pick another day.', slots: [] };
      // Candidate services: the office's own list + per-office service docs.
      let cands = [];
      try {
        const snap = await state.db.collection('services').where('locationKey', '==', locationId).get();
        snap.forEach((d) => cands.push(Object.assign({ id: d.id }, d.data())));
      } catch (e) { /* field may not exist on older catalogs */ }
      if (!this._b2bPickService(cands, course) && Array.isArray(loc.services)) {
        const ids = loc.services.filter((id) => this._b2bPickService([{ id }], course));
        cands = cands.concat((await Promise.all(ids.map((id) => this.getService(id)))).filter(Boolean));
      }
      const svc = this._b2bPickService(cands, course);
      if (!svc) return { ok: false, closedReason: 'This course isn’t offered at that office. Please pick another office or ask us about on-site training.', slots: [] };
      const blocked = await this.getBlockedDates({ locationId, serviceId: svc.id });
      if (blocked[date]) return { ok: false, closedReason: 'That office is closed on the selected date. Please choose another day.', slots: [] };
      const sched = await this.getScheduleSettings();
      const slotList = (svc.slotsByLocation && svc.slotsByLocation[locationId]) || loc.slots || (sched && sched.defaultSlots) || [];
      const times = await this.getBlockedTimes({ locationId, date, serviceId: svc.id });
      let crossLocations = false;
      if (svc.resourceGroup) { const g = await this.getResourceGroup(svc.resourceGroup); crossLocations = !!(g && g.sharedAcrossLocations); }
      const booked = await this.getBookedSlots({ locationId, serviceId: svc.id, resourceGroup: svc.resourceGroup || null, crossLocations, date });
      const max = Number(svc.maxPerSlot) || 1;
      const dur = Number(svc.durationMinutes) || 60;
      const toMin = (t) => { const m = String(t || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*([ap])?/i); if (!m) return null; let h = +m[1] % (m[3] ? 12 : 24); if (m[3] && /p/i.test(m[3])) h += 12; return h * 60 + (+(m[2] || 0)); };
      const slots = slotList.map((t) => {
        const s = toMin(t); const hit = s == null ? null : times.find((b) => s < b.endMin && (s + dur) > b.startMin);
        return { time: t, left: Math.max(0, max - (Number(booked[t]) || 0)), blocked: hit ? (hit.reason || 'Unavailable') : '' };
      });
      return { ok: true, serviceId: svc.id, serviceName: svc.name || svc.id, maxPerSlot: max, slots };
    },

    // Optional { from, to } (YYYY-MM-DD) switches to a date-range query (single-
    // field index on `date`, no cap) — the v2 admin uses that instead of the
    // classic "200 most recently created" list, which stays the default.
    async adminListBookings({ locationId, serviceId, limit = 200, from, to } = {}) {
      await ready();
      if ((from || to) && !state.mock && state.db) {
        let q = state.db.collection('bookings');
        if (from) q = q.where('date', '>=', from);
        if (to) q = q.where('date', '<=', to);
        const rs = await q.get();
        const out = [];
        rs.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
        return out;
      }
      if (state.mock || !state.db) {
        // Build sample bookings for the dashboard preview.
        const now = new Date();
        const rows = [];
        const services = [
          { id: 'bls-self-guided', name: 'BLS — Self-Guided' },
          { id: 'bls-skills-only', name: 'BLS — Skills Only' },
          { id: 'acls', name: 'ACLS' },
          { id: 'cna', name: 'CNA' },
          { id: 'bg-check', name: 'Level 2 Background Check' }
        ];
        const locs = FALLBACK_LOCATIONS;
        const statuses = ['confirmed','pending','confirmed','confirmed','pending','cancelled'];
        for (let i = 0; i < 12; i++) {
          const svc = services[i % services.length];
          const loc = locs[i % locs.length];
          const when = new Date(now.getTime() + (i - 2) * 86400000 + (i * 3600000));
          rows.push({
            id: 'bk_' + (1000 + i),
            customer: ['Alex Johnson','Maria Ramirez','Devon Clarke','Priya Patel','Sam Lee','Rebecca Liu'][i % 6],
            email: ['alex@example.com','maria@example.com','devon@example.com','priya@example.com','sam@example.com','rebecca@example.com'][i % 6],
            phone: '(904) 555-0' + (100 + i),
            service: svc.id,
            serviceName: svc.name,
            location: loc.id,
            locationName: loc.name,
            startsAt: when.toISOString(),
            status: statuses[i % statuses.length],
            hasProof: svc.id === 'bls-skills-only',
            proofUrl: svc.id === 'bls-skills-only' ? '#' : null,
            orderName: '#' + (2041 + i)
          });
        }
        return rows.slice(0, limit);
      }
      // No server-side filtering — staff list filters are applied client-side
      // in loadBookings so we can tolerate the few older docs that stored
      // the display name in `location` instead of the doc id. Single-field
      // orderBy(createdAt) is auto-indexed by Firestore.
      const snap = await state.db.collection('bookings').orderBy('createdAt', 'desc').limit(limit).get();
      const rows = [];
      snap.forEach((d) => rows.push(Object.assign({ id: d.id }, d.data())));
      return rows;
    },

    async adminAddClassDate({ locationId, serviceId, date, startTime, endTime, seatsTotal }) {
      await ready();
      const payload = { date, startTime, endTime, seatsTotal, seatsLeft: seatsTotal, createdAt: new Date().toISOString() };
      if (state.mock || !state.db) return { id: 'class_' + Math.random().toString(36).slice(2, 8), ...payload };
      const doc = await state.db.collection('locations').doc(locationId)
        .collection('services').doc(serviceId)
        .collection('availability').add(payload);
      return { id: doc.id, ...payload };
    },

    /* ----- Admin v2 (full dashboard) ----- */
    async adminUpdateBooking(id, data) {
      await ready();
      if (state.mock || !state.db) return { id, ...data };
      data = Object.assign({}, data, { updatedAt: window.firebase.firestore.FieldValue.serverTimestamp() }); // don't mutate the caller's object
      await state.db.collection('bookings').doc(id).update(data);
      return { id, ...data };
    },
    async adminDeleteBooking(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('bookings').doc(id).delete();
    },
    // Queue an on-demand email to a student (e.g. the IV-access email). Writes
    // an outbound_emails doc; the sendStudentEmail Cloud Function fires the
    // Zapier hook that actually sends it. Staff-only via Firestore rules.
    async adminSendStudentEmail(payload) {
      await ready();
      if (state.mock || !state.db) return { ok: true, mock: true };
      if (!payload || !payload.to) throw new Error('No recipient email.');
      const doc = Object.assign({ status: 'pending', createdAt: window.firebase.firestore.FieldValue.serverTimestamp() }, payload);
      const ref = await state.db.collection('outbound_emails').add(doc);
      return { ok: true, id: ref.id };
    },
    // Take one CONFIRMED seat in a slot_counters doc so a manually-added
    // booking blocks a seat on the customer booking calendar. Keyed exactly
    // like the public flow (_slotCounterKey) so the counts line up. Returns
    // { counterId, time } to store on the booking for later release.
    // Optional maxPerSlot: refuse (code SLOT_FULL) when confirmed + live holds
    // already fill the slot, unless force is true. Omitted = old behaviour.
    async adminReserveSlotSeat({ locationId, serviceId, resourceGroup, crossLocations, date, time, maxPerSlot, force }) {
      await ready();
      if (!date || !time) return null;
      const key = this._slotCounterKey({ locationId, serviceId, resourceGroup, crossLocations });
      const docId = key + '__' + date;
      if (state.mock || !state.db) return { counterId: docId, time };
      const FV = window.firebase.firestore.FieldValue;
      const ref = state.db.collection('slot_counters').doc(docId);
      await state.db.runTransaction(async (tx) => {
        const snap = await tx.get(ref);
        if (!snap.exists) {
          tx.set(ref, { counterKey: key, date, confirmed: { [time]: 1 }, holds: {}, createdAt: FV.serverTimestamp() });
        } else {
          const data = snap.data() || {};
          if (maxPerSlot && !force && this._validCountForTime(data, time, Date.now(), null) >= maxPerSlot) {
            const e = new Error('SLOT_FULL'); e.code = 'SLOT_FULL'; throw e;
          }
          const cur = (data.confirmed && data.confirmed[time]) || 0;
          const upd = {}; upd['confirmed.' + time] = cur + 1;
          tx.update(ref, upd);
        }
      });
      return { counterId: docId, time };
    },
    // Free one confirmed seat (cancel/delete). Never goes below zero.
    // Pass { bookingId, status: 'held' } for an unpaid hold: that removes ONLY
    // its holds entry — a hold was never counted in `confirmed`, so
    // decrementing would free another customer's paid seat.
    async adminReleaseSlotSeat({ counterId, time, bookingId, status }) {
      await ready();
      if (!counterId || !time || state.mock || !state.db) return;
      const ref = state.db.collection('slot_counters').doc(counterId);
      await state.db.runTransaction(async (tx) => {
        const snap = await tx.get(ref);
        if (!snap.exists) return;
        const data = snap.data() || {};
        if (status === 'held') {
          if (!bookingId) return;
          const hs = Object.assign({}, (data.holds && data.holds[time]) || {});
          if (!(bookingId in hs)) return;
          delete hs[bookingId];
          tx.update(ref, { holds: Object.assign({}, data.holds || {}, { [time]: hs }) });
          return;
        }
        const cur = (data.confirmed && data.confirmed[time]) || 0;
        const upd = {}; upd['confirmed.' + time] = Math.max(0, cur - 1);
        tx.update(ref, upd);
      });
    },
    async adminCreateBooking(data) {
      await ready();
      const payload = Object.assign({
        status: 'confirmed',
        source: 'admin',
        createdAt: new Date().toISOString()
      }, data);
      if (state.mock || !state.db) return { id: 'bk_' + Math.random().toString(36).slice(2, 10), ...payload };
      payload.createdAt = window.firebase.firestore.FieldValue.serverTimestamp();
      const ref = await state.db.collection('bookings').add(payload);
      return { id: ref.id, ...payload };
    },

    // Public-facing booking writer for the fingerprint + CNA forms, which
    // add to cart via a native /cart/add POST rather than the slot-hold
    // flow. Writes a status:'pending' booking (the only status the
    // Firestore create rule allows unauthenticated visitors) so the
    // appointment shows up in the admin scheduling tab. The orders/paid
    // webhook flips it to 'confirmed' once payment completes, keyed by the
    // Booking ID we drop into the cart line item.
    async createPublicBooking(data) {
      await ready();
      if (state.mock || !state.db) return { id: 'bk_' + Math.random().toString(36).slice(2, 10), mock: true };
      const FV = window.firebase.firestore.FieldValue;
      const payload = Object.assign({ createdAt: FV.serverTimestamp() }, data, { status: 'pending' });
      const ref = await state.db.collection('bookings').add(payload);
      return { id: ref.id };
    },

    // Event lead-capture (Florida Elks convention etc.). Writes to the
    // public-create-only `elks_registrations` collection. No PII is ever
    // read back without staff auth.
    async submitElksRegistration(data) {
      await ready();
      if (state.mock || !state.db) return { id: 'elk_' + Math.random().toString(36).slice(2, 10), mock: true };
      const FV = window.firebase.firestore.FieldValue;
      const ref = await state.db.collection('elks_registrations').add(Object.assign({ createdAt: FV.serverTimestamp() }, data));
      return { id: ref.id };
    },
    async adminListElksRegistrations() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('elks_registrations').orderBy('createdAt', 'desc').limit(2000).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminDeleteElksRegistration(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('elks_registrations').doc(id).delete();
    },

    // Onsite/group training inquiries (sm-onsite-form). Public create,
    // staff read. Records the same data the form emails to the store
    // owner so it also shows on the admin Inquiries tab.
    async submitOnsiteInquiry(data) {
      await ready();
      if (state.mock || !state.db) return { id: 'inq_' + Math.random().toString(36).slice(2, 10), mock: true };
      const FV = window.firebase.firestore.FieldValue;
      // Server-controlled fields go last so a submission can't preset its
      // own status / quote link / timestamp.
      const clean = Object.assign({}, data);
      ['status', 'createdAt', 'updatedAt', 'quoteId', 'notes', 'officeId'].forEach((k) => { delete clean[k]; });
      const payload = Object.assign({ source: 'onsite-form' }, clean, { createdAt: FV.serverTimestamp(), status: 'new' });
      const ref = await state.db.collection('onsite_inquiries').add(payload);
      return { id: ref.id };
    },
    async adminListOnsiteInquiries() {
      await ready();
      if (state.mock || !state.db) return [];
      // Newest 300 plus every still-open lead (new/contacted/quoted), so the
      // status filter never loses older open inquiries.
      const col = state.db.collection('onsite_inquiries');
      const [recent, open] = await Promise.all([
        col.orderBy('createdAt', 'desc').limit(300).get(),
        col.where('status', 'in', ['new', 'contacted', 'quoted']).limit(500).get()
      ]);
      const byId = {};
      recent.forEach((d) => { byId[d.id] = Object.assign({ id: d.id }, d.data()); });
      open.forEach((d) => { byId[d.id] = Object.assign({ id: d.id }, d.data()); });
      const ms = (v) => (v && v.toDate ? v.toDate().getTime() : (v && v.seconds ? v.seconds * 1000 : (Date.parse(v) || 0)));
      return Object.values(byId).sort((a, b) => ms(b.createdAt) - ms(a.createdAt));
    },
    async adminUpdateOnsiteInquiry(id, data) {
      await ready();
      if (state.mock || !state.db) return { id, ...data };
      const FV = window.firebase.firestore.FieldValue;
      await state.db.collection('onsite_inquiries').doc(id).set(Object.assign({ updatedAt: FV.serverTimestamp() }, data), { merge: true });
      return { id, ...data };
    },
    async adminDeleteOnsiteInquiry(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('onsite_inquiries').doc(id).delete();
    },

    // Booking matcher failures. Captures a snapshot every time the booking
    // flow can't resolve a Shopify variant for the (course × location)
    // combination the customer picked. Staff can use this to diagnose
    // why the "is not offered at this location" message shows up.
    async logBookingFailure(data) {
      await ready();
      if (state.mock || !state.db) return { id: 'fail_' + Math.random().toString(36).slice(2, 10), mock: true };
      const FV = window.firebase.firestore.FieldValue;
      try {
        const ref = await state.db.collection('booking_failures').add(Object.assign({
          createdAt: FV.serverTimestamp(),
          userAgent: (typeof navigator !== 'undefined' && navigator.userAgent) || '',
          url: (typeof location !== 'undefined' && location.href) || ''
        }, data));
        return { id: ref.id };
      } catch (e) {
        console.warn('[StatMed] logBookingFailure failed (continuing)', e);
        return { id: null, error: e.message };
      }
    },
    async adminListBookingFailures() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('booking_failures').orderBy('createdAt', 'desc').limit(200).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminDeleteBookingFailure(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('booking_failures').doc(id).delete();
    },

    // Asset / inventory tracker — staff-only across the board. CPR
    // manikins, AED trainers, laptops, scanners, RQI stations, etc.
    async adminListAssets() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('assets').orderBy('createdAt', 'desc').limit(1000).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminSaveAsset(id, data) {
      await ready();
      const payload = Object.assign({}, data);
      // A blank quantity used to be saved as null, which made the item
      // impossible to check out. Default to 1 and reject nonsense.
      if (payload.qty == null || payload.qty === '') { if (!id) payload.qty = 1; else delete payload.qty; }
      else {
        const q = parseInt(payload.qty, 10);
        if (isNaN(q) || q < 0) throw new Error('Quantity must be a whole number (0 or more).');
        payload.qty = q;
      }
      if (state.mock || !state.db) return { id: id || ('asset_' + Math.random().toString(36).slice(2,10)), ...payload };
      const FV = window.firebase.firestore.FieldValue;
      payload.updatedAt = FV.serverTimestamp();
      if (id) {
        await state.db.collection('assets').doc(id).set(payload, { merge: true });
        return { id, ...payload };
      }
      payload.createdAt = FV.serverTimestamp();
      const ref = await state.db.collection('assets').add(payload);
      return { id: ref.id, ...payload };
    },
    async adminDeleteAsset(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('assets').doc(id).delete();
    },

    // Asset checkouts — one doc per check-out event. Each carries the
    // expected return date, destination, reason, and an items array
    // where each entry is { assetId, name, category, qty, qtyReturned,
    // firstReturnedAt, lastReturnedAt }. Multi-unit assets (e.g. 18
    // BVMs) check out a partial qty; returns decrement qtyReturned
    // until it equals qty. When all items are fully returned the
    // doc flips to status:"completed".
    async adminListAssetCheckouts({ activeOnly = false } = {}) {
      await ready();
      if (state.mock || !state.db) return [];
      let q = state.db.collection('asset_checkouts').orderBy('createdAt', 'desc').limit(500);
      const snap = await q.get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return activeOnly ? out.filter((c) => c.status === 'active') : out;
    },
    async adminCreateAssetCheckout(data) {
      await ready();
      const FV = (!state.mock && window.firebase && window.firebase.firestore) ? window.firebase.firestore.FieldValue : null;
      const signedIn = (state.auth && state.auth.currentUser && state.auth.currentUser.email) || '';
      const items = (data.items || []).map((it) => {
        const qty = Math.max(1, parseInt(it.qty, 10) || 1);
        return {
          assetId: it.assetId,
          name: it.name || '',
          category: it.category || '',
          qty: qty,
          qtyReturned: 0,
          firstReturnedAt: null,
          lastReturnedAt: null
        };
      });
      const unitsOut = items.reduce((n, it) => n + it.qty, 0);
      const payload = {
        expectedReturn: (data.expectedReturn || '').trim(),
        destination: (data.destination || '').trim(),
        reason: (data.reason || '').trim(),
        items: items,
        itemCount: items.length,
        unitsOut: unitsOut,
        remainingCount: unitsOut,
        status: 'active',
        createdAt: FV ? FV.serverTimestamp() : new Date().toISOString(),
        // Who recorded it (the signed-in user) and who has the equipment.
        createdBy: (data.createdBy || signedIn || '').trim().toLowerCase(),
        checkedOutByName: (data.checkedOutByName || '').trim(),
        checkedOutByEmail: (data.checkedOutByEmail || '').trim().toLowerCase(),
        officeId: (data.officeId || '').trim(),
        completedAt: null
      };
      if (state.mock || !state.db) return { id: 'co_' + Math.random().toString(36).slice(2,10), ...payload };
      const ref = await state.db.collection('asset_checkouts').add(payload);
      return { id: ref.id, ...payload };
    },
    async adminGetAssetCheckout(id) {
      await ready();
      if (state.mock || !state.db) return null;
      const snap = await state.db.collection('asset_checkouts').doc(id).get();
      return snap.exists ? Object.assign({ id: snap.id }, snap.data()) : null;
    },
    // Atomically return N units of an asset on a checkout. Pass qty=1
    // for single-unit assets; for multi-unit assets pass however many
    // are coming back in this scan. Returns updated remaining count
    // and whether the checkout is now fully completed.
    async adminReturnAssetItem(checkoutId, assetId, qty, returnedBy) {
      await ready();
      const n = Math.max(1, parseInt(qty, 10) || 1);
      const by = String(returnedBy || (state.auth && state.auth.currentUser && state.auth.currentUser.email) || '').toLowerCase();
      if (state.mock || !state.db) return { ok: true, mock: true, remaining: 0, completed: true, returnedQty: n };
      const ref = state.db.collection('asset_checkouts').doc(checkoutId);
      const FV = window.firebase.firestore.FieldValue;
      return state.db.runTransaction(async (tx) => {
        const snap = await tx.get(ref);
        if (!snap.exists) { const e = new Error('Checkout not found'); e.code = 'NOT_FOUND'; throw e; }
        const data = snap.data() || {};
        if (data.status !== 'active') { const e = new Error('Already completed'); e.code = 'ALREADY_DONE'; throw e; }
        const items = (data.items || []).slice();
        const idx = items.findIndex((it) => it.assetId === assetId && ((it.qty || 0) - (it.qtyReturned || 0)) > 0);
        if (idx < 0) { const e = new Error('Item not on this checkout (or all units already returned)'); e.code = 'NOT_OUT'; throw e; }
        const it = Object.assign({}, items[idx]);
        const outstanding = (it.qty || 0) - (it.qtyReturned || 0);
        if (n > outstanding) { const e = new Error('Returning more than what is out (' + outstanding + ' remaining)'); e.code = 'OVER_RETURN'; throw e; }
        const nowIso = new Date().toISOString();
        it.qtyReturned = (it.qtyReturned || 0) + n;
        if (!it.firstReturnedAt) it.firstReturnedAt = nowIso;
        it.lastReturnedAt = nowIso;
        it.lastReturnedBy = by;
        items[idx] = it;
        const remaining = items.reduce((s, x) => s + Math.max(0, (x.qty || 0) - (x.qtyReturned || 0)), 0);
        const returns = (data.returns || []).concat([{ assetId: assetId, name: it.name || '', qty: n, at: nowIso, by: by }]);
        const update = { items: items, remainingCount: remaining, returns: returns };
        if (remaining === 0) {
          update.status = 'completed';
          update.completedAt = FV.serverTimestamp();
          update.completedBy = by;
        }
        tx.update(ref, update);
        return { ok: true, remaining: remaining, completed: remaining === 0, returnedQty: n, returnedItem: it };
      });
    },

    // ────────────────────────────────────────────────────────────────
    // Employees — staff-only across the board. Each doc holds basic
    // info, employment details, qualifications, scheduling prefs,
    // payroll info, and a documents[] index that points to files in
    // Firebase Storage under employees/<docId>/<filename>.
    // ────────────────────────────────────────────────────────────────
    async adminListEmployees() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('employees').orderBy('lastName', 'asc').limit(1000).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminGetEmployee(id) {
      await ready();
      if (state.mock || !state.db) return null;
      const snap = await state.db.collection('employees').doc(id).get();
      return snap.exists ? Object.assign({ id: snap.id }, snap.data()) : null;
    },
    async adminSaveEmployee(id, data) {
      await ready();
      const payload = Object.assign({}, data);
      if (state.mock || !state.db) return { id: id || ('emp_' + Math.random().toString(36).slice(2,10)), ...payload };
      const FV = window.firebase.firestore.FieldValue;
      payload.updatedAt = FV.serverTimestamp();
      if (id) {
        await state.db.collection('employees').doc(id).set(payload, { merge: true });
        return { id, ...payload };
      }
      payload.createdAt = FV.serverTimestamp();
      payload.documents = payload.documents || [];
      const ref = await state.db.collection('employees').add(payload);
      return { id: ref.id, ...payload };
    },
    // opts.deleteFiles: also delete everything under employees/<id>/ in
    // Storage (HR documents + photo). Returns { filesLeft } = files that
    // could not be deleted. Without opts the files are kept (old behaviour).
    async adminDeleteEmployee(id, opts) {
      await ready();
      if (state.mock || !state.db) return { filesLeft: 0 };
      let filesLeft = 0;
      if (opts && opts.deleteFiles && state.storage) {
        try {
          const res = await state.storage.ref('employees/' + id).listAll();
          for (const it of res.items) { try { await it.delete(); } catch (e) { filesLeft++; } }
        } catch (e) { console.warn('[employees] could not list files for cleanup', e); filesLeft = -1; }
      }
      await state.db.collection('employees').doc(id).delete();
      return { filesLeft: filesLeft };
    },

    // Upload a single document to employees/<empId>/<timestamp>-<name>.
    // Returns metadata to append to the employee's documents[] array.
    async adminUploadEmployeeDoc(empId, file, label) {
      await ready();
      if (!empId) throw new Error('Save the employee first, then upload documents.');
      if (state.mock || !state.storage) {
        return { path: 'mock/employees/' + empId + '/' + file.name, url: '', name: file.name, label: label || '', size: file.size || 0, contentType: file.type || '', uploadedAt: new Date().toISOString() };
      }
      const safeName = (file.name || 'document').replace(/[^a-z0-9._-]/gi, '_');
      const key = Date.now() + '-' + safeName;
      const ref = state.storage.ref().child('employees/' + empId + '/' + key);
      const snap = await ref.put(file);
      const url = await snap.ref.getDownloadURL();
      return {
        path: snap.ref.fullPath,
        url: url,
        name: file.name || safeName,
        label: (label || '').trim(),
        size: file.size || 0,
        contentType: file.type || '',
        uploadedAt: new Date().toISOString()
      };
    },
    // Remove a document from Storage. The Firestore documents[] entry
    // is removed by the calling code via adminSaveEmployee.
    async adminDeleteEmployeeDoc(path) {
      await ready();
      if (state.mock || !state.storage) return;
      if (!path) return;
      try { await state.storage.ref().child(path).delete(); }
      catch (err) { console.warn('[employees] storage delete failed (will still drop the metadata)', err); }
    },

    // Profile photo. One per employee — replacing the photo deletes the
    // old file before uploading the new one so Storage doesn't fill up
    // with orphans. Returns { photoUrl, photoPath } that the caller
    // merges into the employee doc.
    async adminUploadEmployeePhoto(empId, file, prevPath) {
      await ready();
      if (!empId) throw new Error('Save the employee first.');
      if (state.mock || !state.storage) {
        return { photoUrl: '', photoPath: 'mock/employees/' + empId + '/photo' };
      }
      const safeName = (file.name || 'photo').replace(/[^a-z0-9._-]/gi, '_');
      const key = 'photo-' + Date.now() + '-' + safeName;
      const ref = state.storage.ref().child('employees/' + empId + '/' + key);
      const snap = await ref.put(file);
      const url = await snap.ref.getDownloadURL();
      if (prevPath && prevPath !== snap.ref.fullPath) {
        try { await state.storage.ref().child(prevPath).delete(); }
        catch (_) {}
      }
      await state.db.collection('employees').doc(empId).set({ photoUrl: url, photoPath: snap.ref.fullPath }, { merge: true });
      return { photoUrl: url, photoPath: snap.ref.fullPath };
    },
    async adminDeleteEmployeePhoto(empId, path) {
      await ready();
      if (state.mock || !state.storage) return;
      if (path) { try { await state.storage.ref().child(path).delete(); } catch (_) {} }
      await state.db.collection('employees').doc(empId).set({ photoUrl: window.firebase.firestore.FieldValue.delete(), photoPath: window.firebase.firestore.FieldValue.delete() }, { merge: true });
    },

    // ────────────────────────────────────────────────────────────────
    // Schedule events — shifts, assigned classes, unavailability,
    // company events. Staff-only across the board for now; Phase 1.B
    // will open create access to employees for self-serve time-off
    // requests with status:"requested".
    // ────────────────────────────────────────────────────────────────
    async adminListScheduleEvents({ startDate, endDate, employeeId } = {}) {
      await ready();
      if (state.mock || !state.db) return [];
      let q = state.db.collection('schedule_events');
      if (employeeId) q = q.where('employeeId', '==', employeeId);
      // Firestore can't combine range + equality cheaply, so we filter
      // by date range client-side after fetching.
      const snap = await q.limit(2000).get();
      const out = [];
      snap.forEach((d) => {
        const e = Object.assign({ id: d.id }, d.data());
        if (startDate && e.end && e.end < startDate) return;
        if (endDate && e.start && e.start > endDate) return;
        out.push(e);
      });
      return out;
    },
    async adminSaveScheduleEvent(id, data) {
      await ready();
      const FV = window.firebase.firestore.FieldValue;
      const payload = Object.assign({}, data, { updatedAt: FV.serverTimestamp() });
      if (state.mock || !state.db) return { id: id || ('sched_' + Math.random().toString(36).slice(2,10)), ...payload };
      if (id) {
        await state.db.collection('schedule_events').doc(id).set(payload, { merge: true });
        return { id, ...payload };
      }
      payload.createdAt = FV.serverTimestamp();
      const ref = await state.db.collection('schedule_events').add(payload);
      return { id: ref.id, ...payload };
    },
    async adminDeleteScheduleEvent(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('schedule_events').doc(id).delete();
    },
    // Admin approval helpers.
    async adminListPendingScheduleRequests() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('schedule_events').where('status', '==', 'requested').limit(500).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => String(a.start || '').localeCompare(String(b.start || '')));
      return out;
    },
    async adminApproveScheduleRequest(id) {
      await ready();
      if (state.mock || !state.db) return;
      const ref = state.db.collection('schedule_events').doc(id);
      const patch = {
        status: 'planned',
        approvedAt: window.firebase.firestore.FieldValue.serverTimestamp()
      };
      // Requests are saved with employeeId '' (the requester may not be able
      // to read employees). Link it now so conflicts + employee filters work.
      try {
        const snap = await ref.get();
        const ev = snap.exists ? (snap.data() || {}) : {};
        if (!ev.employeeId && ev.employeeEmail) {
          const emp = await findEmployeeByEmail(ev.employeeEmail);
          if (emp) {
            patch.employeeId = emp.id;
            if (!ev.employeeName) patch.employeeName = employeeDisplayName(emp);
          }
        }
      } catch (e) { console.warn('[schedule] employee link on approve failed', e); }
      await ref.set(patch, { merge: true });
    },
    async adminDenyScheduleRequest(id, reason) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('schedule_events').doc(id).set({
        status: 'denied',
        deniedReason: (reason || '').trim(),
        deniedAt: window.firebase.firestore.FieldValue.serverTimestamp()
      }, { merge: true });
    },

    // ────────────────────────────────────────────────────────────────
    // Staff-facing (employee) schedule self-serve. These call paths
    // assume the user is signed in via Firebase Auth. The Firestore
    // rule restricts results to events whose employeeEmail matches
    // the auth email — so an employee cannot see other people's data
    // even if they crafted a custom query.
    // ────────────────────────────────────────────────────────────────
    async staffListMyEvents() {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in to view your schedule.');
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('schedule_events')
        .where('employeeEmail', '==', (user.email || '').toLowerCase())
        .limit(500)
        .get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => String(a.start || '').localeCompare(String(b.start || '')));
      return out;
    },
    async staffSubmitTimeOffRequest({ startDate, endDate, startTime, endTime, allDay, reason }) {
      await ready();
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in to submit a request.');
      if (!startDate) throw new Error('Pick a start date.');
      const sd = startDate;
      const ed = endDate || startDate;
      const st = allDay ? '00:00' : (startTime || '00:00');
      const et = allDay ? '23:59' : (endTime || '23:59');
      if (ed < sd) throw new Error('The end date is before the start date.');
      if (ed === sd && et <= st) throw new Error('The end time must be after the start time.');
      // Link the employee record when this account can read it (staff);
      // otherwise approval fills employeeId in (adminApproveScheduleRequest).
      const emp = state.mock ? null : await findEmployeeByEmail(user.email);
      const payload = {
        type: 'unavailable',
        title: 'Time off — ' + (reason || 'requested'),
        start: sd + 'T' + st,
        end:   ed + 'T' + et,
        employeeId: emp ? emp.id : '',
        employeeName: (emp && employeeDisplayName(emp)) || user.displayName || '',
        employeeEmail: (user.email || '').toLowerCase(),
        location: (emp && emp.workLocation) || '',
        notes: reason || '',
        reason: reason || '',
        status: 'requested',
        allDay: !!allDay,
        createdAt: window.firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: window.firebase.firestore.FieldValue.serverTimestamp()
      };
      if (state.mock || !state.db) return { id: 'req_' + Math.random().toString(36).slice(2,10), ...payload };
      const ref = await state.db.collection('schedule_events').add(payload);
      return { id: ref.id, ...payload };
    },

    // ────────────────────────────────────────────────────────────────
    // Quotes — on-site / private group training proposals. Lifecycle:
    //   draft → sent → accepted (or rejected/expired) → completed.
    // When marked accepted, the app also creates a class-type schedule
    // event so an admin can assign instructors. The quote and the
    // schedule event link back to each other via quoteId / linkedScheduleEventId.
    // ────────────────────────────────────────────────────────────────
    async adminListQuotes() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('quotes').orderBy('createdAt', 'desc').limit(1000).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminGetQuote(id) {
      await ready();
      if (state.mock || !state.db) return null;
      const snap = await state.db.collection('quotes').doc(id).get();
      return snap.exists ? Object.assign({ id: snap.id }, snap.data()) : null;
    },
    // Saving with status 'accepted' runs the same accept flow as the
    // "Mark accepted" button (creates or updates the ONE linked calendar
    // class), and saving an already-accepted quote keeps that class's
    // date/time/location in step with the quote.
    async adminSaveQuote(id, data) {
      await ready();
      if (state.mock || !state.db) return { id: id || ('q_' + Math.random().toString(36).slice(2,10)), ...data };
      const FV = window.firebase.firestore.FieldValue;
      const payload = Object.assign({}, data, { updatedAt: FV.serverTimestamp() });
      let saved;
      if (id) {
        // Existing quote — only mint a publicToken if one doesn't exist yet.
        // (Old quotes created before this feature won't have one.)
        const cur = await state.db.collection('quotes').doc(id).get();
        if (!cur.exists || !cur.data().publicToken) {
          payload.publicToken = genPublicToken();
        }
        await state.db.collection('quotes').doc(id).set(payload, { merge: true });
        saved = Object.assign({ id }, cur.exists ? cur.data() : {}, payload);
      } else {
        payload.createdAt = FV.serverTimestamp();
        payload.status = payload.status || 'draft';
        payload.publicToken = genPublicToken();
        const ref = await state.db.collection('quotes').add(payload);
        saved = { id: ref.id, ...payload };
      }
      if (saved.status === 'accepted') {
        const r = await this._syncQuoteEvent(saved.id);
        saved.linkedScheduleEventId = r.scheduleEventId;
      }
      return saved;
    },
    // Create or update the calendar class linked to a quote. Reuses
    // linkedScheduleEventId (or any event already pointing at the quote via
    // linkedQuoteId) so revert + re-accept never makes a second event.
    async _syncQuoteEvent(id) {
      const FV = window.firebase.firestore.FieldValue;
      const ref = state.db.collection('quotes').doc(id);
      const snap = await ref.get();
      if (!snap.exists) throw new Error('Quote not found.');
      const q = snap.data() || {};
      const date = (q.serviceDate || '').trim();
      if (!date) throw new Error('Quote needs a service date before it can be accepted.');
      const evCol = state.db.collection('schedule_events');
      let evId = q.linkedScheduleEventId || q.scheduleEventId || '';
      let ev = evId ? await evCol.doc(evId).get() : null;
      if (!ev || !ev.exists) {
        const found = await evCol.where('linkedQuoteId', '==', id).limit(1).get();
        ev = found.empty ? null : found.docs[0];
        evId = ev ? ev.id : '';
      }
      const total = (q.totalAmount != null && q.totalAmount !== '') ? q.totalAmount : 0;
      const eventPayload = {
        type: 'class',
        title: (q.serviceType || 'Training') + ' — ' + (q.companyName || 'Client'),
        start: date + 'T' + (q.startTime || '08:00'),
        end:   date + 'T' + (q.endTime || '17:00'),
        location: q.location || '',
        notes: 'Quote: ' + (q.companyName || '') + ' · ' + (q.studentsCount || 0) + ' students · $' + total,
        linkedQuoteId: id,
        updatedAt: FV.serverTimestamp()
      };
      let created = false;
      if (ev) {
        const cur = ev.data() || {};
        if (cur.status === 'cancelled' || cur.status === 'denied') eventPayload.status = 'planned';
        await evCol.doc(evId).set(eventPayload, { merge: true });
      } else {
        Object.assign(eventPayload, { employeeId: '', employeeName: '', employeeEmail: '', status: 'planned', createdAt: FV.serverTimestamp() });
        evId = (await evCol.add(eventPayload)).id;
        created = true;
      }
      const qPatch = { status: 'accepted', linkedScheduleEventId: evId, updatedAt: FV.serverTimestamp() };
      if (!q.acceptedAt) qPatch.acceptedAt = FV.serverTimestamp();
      await ref.set(qPatch, { merge: true });
      return { ok: true, scheduleEventId: evId, created };
    },
    // Deleting a quote also removes its calendar class (no orphans).
    async adminDeleteQuote(id) {
      await ready();
      if (state.mock || !state.db) return;
      const ref = state.db.collection('quotes').doc(id);
      const snap = await ref.get();
      const evId = snap.exists ? (snap.data().linkedScheduleEventId || '') : '';
      if (evId) { try { await state.db.collection('schedule_events').doc(evId).delete(); } catch (e) { console.warn('[quotes] linked event delete failed', e); } }
      await ref.delete();
    },
    // Mark a quote accepted AND put its class on the calendar. Idempotent:
    // an existing linked event is updated in place, never duplicated.
    async adminAcceptQuote(id) {
      await ready();
      if (state.mock || !state.db) {
        return { ok: true, mock: true, scheduleEventId: 'mock_sched' };
      }
      const snap = await state.db.collection('quotes').doc(id).get();
      if (!snap.exists) throw new Error('Quote not found.');
      const was = snap.data() || {};
      const r = await this._syncQuoteEvent(id);
      if (was.status === 'accepted' && (was.linkedScheduleEventId || '') === r.scheduleEventId) r.alreadyAccepted = true;
      return r;
    },

    async adminAddBlockedDate({ locationId, startDate, endDate, services, resourceGroups, adminOnly, reason }) {
      await ready();
      if (!locationId) throw new Error('Pick an office.');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(String(startDate || ''))) throw new Error('Pick a start date.');
      if (endDate && endDate < startDate) throw new Error('The end date is before the start date. Fix the dates and save again.');
      const payload = {
        location: locationId,
        startDate,
        endDate: endDate || startDate,
        services: services || [],
        resourceGroups: resourceGroups || [],
        adminOnly: !!adminOnly,
        reason: reason || '',
        createdAt: new Date().toISOString()
      };
      if (state.mock || !state.db) return { id: 'bd_' + Math.random().toString(36).slice(2, 8), ...payload };
      const ref = await state.db.collection('blocked_dates').add(payload);
      return { id: ref.id, ...payload };
    },
    async adminListBlockedDates(locationId) {
      await ready();
      if (state.mock || !state.db) return [];
      let q = state.db.collection('blocked_dates').orderBy('startDate', 'desc').limit(200);
      if (locationId) q = q.where('location', '==', locationId);
      const snap = await q.get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminDeleteBlockedDate(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('blocked_dates').doc(id).delete();
    },

    // Block a time range on one date at one location. Stored as minutes
    // past midnight (startMinutes/endMinutes) for reliable overlap checks,
    // plus human labels for display. Read by getBlockedTimes on the
    // customer booking calendar to hide any slot that overlaps the range.
    async adminAddBlockedTime({ locationId, date, startMinutes, endMinutes, startLabel, endLabel, services, reason }) {
      await ready();
      if (!locationId) throw new Error('Pick an office.');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(String(date || ''))) throw new Error('Pick a date.');
      if (typeof startMinutes !== 'number' || typeof endMinutes !== 'number' || endMinutes <= startMinutes) throw new Error('End time must be after start time.');
      const payload = {
        location: locationId,
        date,
        startMinutes: startMinutes,
        endMinutes: endMinutes,
        startLabel: startLabel || '',
        endLabel: endLabel || '',
        // services empty = blocks all services; otherwise only the listed services
        services: services || [],
        reason: reason || '',
        createdAt: new Date().toISOString()
      };
      if (state.mock || !state.db) return { id: 'bt_' + Math.random().toString(36).slice(2, 8), ...payload };
      const ref = await state.db.collection('blocked_times').add(payload);
      return { id: ref.id, ...payload };
    },
    // Public read: blocked time ranges for a location on a given date.
    // Single-field query (location) + in-memory date filter avoids needing
    // a composite Firestore index. Returns [{ startMin, endMin, reason }].
    // Options as getBlockedDates plus `date`. Reads only that date's docs
    // (single-field equality) and filters the office in memory.
    async getBlockedTimes({ locationId, date, serviceId, resourceGroup, family, serviceIds, includeAdminOnly } = {}) {
      await ready();
      if (state.mock || !state.db || !locationId || !date) return [];
      const docs = [];
      const take = (snap) => snap.forEach((d) => { const x = d.data() || {}; if (x.location === locationId) docs.push(Object.assign({ id: d.id }, x)); });
      try {
        take(await state.db.collection('blocked_times').where('date', '==', date).get());
      } catch (e) {
        try { take(await state.db.collection('blocked_times').where('location', '==', locationId).get()); }
        catch (e2) { console.warn('[StatMed] getBlockedTimes failed', e2); return []; }
      }
      const ctx = await this._blockCtxResolved({ serviceId, serviceIds, resourceGroup, family, includeAdminOnly }, docs);
      return this._blockedTimesFromDocs(docs, date, ctx);
    },
    async adminListBlockedTimes(locationId) {
      await ready();
      if (state.mock || !state.db) return [];
      let q = state.db.collection('blocked_times');
      if (locationId) q = q.where('location', '==', locationId);
      const snap = await q.get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')) ||
                         ((a.startMinutes || 0) - (b.startMinutes || 0)));
      return out;
    },
    async adminDeleteBlockedTime(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('blocked_times').doc(id).delete();
    },

    async adminListLocationsAll() {
      await ready();
      if (state.mock || !state.db) return FALLBACK_LOCATIONS.slice();
      const snap = await state.db.collection('locations').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id));
      return out;
    },
    async adminSaveLocation(id, data) {
      await ready();
      if (state.mock || !state.db) return { id, ...data };
      await state.db.collection('locations').doc(id).set(data, { merge: true });
      return { id, ...data };
    },
    async adminDeleteLocation(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('locations').doc(id).delete();
    },

    async adminListServicesAll() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('services').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id));
      return out;
    },
    // Save (create or update) a service. Every field passed is written as a
    // whole (mergeFields), so per-office maps like slotsByLocation REPLACE the
    // stored map — clearing one office's override now sticks (a deep merge
    // used to keep it). Fields not passed are left alone. A brand-new service
    // tied to one office (locationKey) is also added to that office's
    // services[] list, which is what the booking widget checks.
    async adminSaveService(id, data) {
      await ready();
      if (state.mock || !state.db) return { id, ...data };
      data = data || {};
      const ref = state.db.collection('services').doc(id);
      const before = await ref.get();
      const keys = Object.keys(data);
      if (keys.length) await ref.set(data, { mergeFields: keys });
      else if (!before.exists) await ref.set({});
      if (!before.exists && data.locationKey && data.active !== false) {
        const FV = window.firebase.firestore.FieldValue;
        try { await state.db.collection('locations').doc(String(data.locationKey)).update({ services: FV.arrayUnion(id) }); }
        catch (e) { console.warn('[StatMed] could not add new service to its office list', e); }
      }
      return { id, ...data };
    },
    // Delete a service and take its id out of every office's services[] list
    // so no office keeps offering a service that no longer exists.
    async adminDeleteService(id) {
      await ready();
      if (state.mock || !state.db) return;
      const FV = window.firebase.firestore.FieldValue;
      try {
        const locs = await state.db.collection('locations').where('services', 'array-contains', id).get();
        const batch = state.db.batch();
        locs.forEach((d) => batch.update(d.ref, { services: FV.arrayRemove(id) }));
        if (!locs.empty) await batch.commit();
      } catch (e) { console.warn('[StatMed] could not remove service from office lists', e); }
      await state.db.collection('services').doc(id).delete();
    },

    // CNA classes (scheduled multi-week cohorts). Stored in collection
    // `cna_classes`. Public read is fine (no PII); writes are staff-only.
    async adminListCnaClasses() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('cna_classes').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => String(a.startDate || '').localeCompare(String(b.startDate || '')));
      return out;
    },
    // Public read for the storefront registration form. Returns active
    // classes, optionally filtered to a location and to upcoming cohorts
    // (endDate today or later).
    async getCnaClasses({ location, locationId, futureOnly = true } = {}) {
      await ready();
      location = location || locationId;
      if (state.mock || !state.db) return [];
      let snap;
      try {
        snap = await state.db.collection('cna_classes').where('active','==',true).get();
      } catch (e) {
        console.warn('[StatMed] getCnaClasses failed', e);
        return [];
      }
      const today = easternToday();
      const out = [];
      snap.forEach((d) => {
        const c = Object.assign({ id: d.id }, d.data());
        if (location && c.location !== location) return;
        if (futureOnly && c.endDate && c.endDate < today) return;
        out.push(c);
      });
      out.sort((a, b) => String(a.startDate || '').localeCompare(String(b.startDate || '')));
      return out;
    },
    async adminSaveCnaClass(id, data) {
      await ready();
      if (state.mock || !state.db) return { id: id || 'mock', ...data };
      if (id) {
        await state.db.collection('cna_classes').doc(id).set(data, { merge: true });
        return { id, ...data };
      }
      const ref = await state.db.collection('cna_classes').add(data);
      return { id: ref.id, ...data };
    },
    // Refuse to delete a class that still has students (any booking with this
    // classId that isn't cancelled) — deleting would orphan their bookings and
    // deposits. Callers should cancel the class instead (status:'cancelled').
    async assertClassHasNoStudents(classId) {
      await ready();
      if (state.mock || !state.db || !classId) return;
      const snap = await state.db.collection('bookings').where('classId', '==', classId).get();
      let n = 0;
      snap.forEach((d) => { if ((d.data() || {}).status !== 'cancelled') n += 1; });
      if (n) {
        const e = new Error(n + (n === 1 ? ' student is' : ' students are') + ' enrolled in this class, so it can\'t be deleted. Mark it inactive (or cancel it in the new staff app) instead.');
        e.code = 'CLASS_HAS_STUDENTS';
        throw e;
      }
    },
    async adminDeleteCnaClass(id) {
      await ready();
      if (state.mock || !state.db) return;
      await api.assertClassHasNoStudents(id);
      await state.db.collection('cna_classes').doc(id).delete();
    },
    // Atomically reserve one seat in a CNA class. Reads the doc inside a
    // transaction, rejects with SEATS_FULL if seatsBooked >= seatsTotal,
    // otherwise increments seatsBooked. Returns the new seat counts.
    async reserveCnaSeat(classId) {
      await ready();
      if (state.mock || !state.db) return { ok: true, mock: true };
      const ref = state.db.collection('cna_classes').doc(classId);
      const FV = window.firebase.firestore.FieldValue;
      return state.db.runTransaction(async (tx) => {
        const snap = await tx.get(ref);
        if (!snap.exists) { const e = new Error('Class not found'); e.code = 'NOT_FOUND'; throw e; }
        const data = snap.data() || {};
        const total = data.seatsTotal || 0;
        const booked = data.seatsBooked || 0;
        if (total && booked >= total) { const e = new Error('SEATS_FULL'); e.code = 'SEATS_FULL'; throw e; }
        tx.update(ref, { seatsBooked: FV.increment(1) });
        return { ok: true, seatsBooked: booked + 1, seatsTotal: total };
      });
    },

    // IV certification classes. Same shape as cna_classes: per-day sessions
    // (date + start/end), location, seatsTotal/seatsBooked, active flag.
    async adminListIvClasses() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('iv_classes').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => String(a.startDate || '').localeCompare(String(b.startDate || '')));
      return out;
    },
    async getIvClasses({ location, futureOnly = true } = {}) {
      await ready();
      if (state.mock || !state.db) return [];
      let snap;
      try {
        snap = await state.db.collection('iv_classes').where('active','==',true).get();
      } catch (e) {
        console.warn('[StatMed] getIvClasses failed', e);
        return [];
      }
      const today = easternToday();
      const out = [];
      snap.forEach((d) => {
        const c = Object.assign({ id: d.id }, d.data());
        if (location && c.location !== location) return;
        if (futureOnly && c.endDate && c.endDate < today) return;
        out.push(c);
      });
      out.sort((a, b) => String(a.startDate || '').localeCompare(String(b.startDate || '')));
      return out;
    },
    async adminSaveIvClass(id, data) {
      await ready();
      if (state.mock || !state.db) return { id: id || 'mock', ...data };
      if (id) {
        await state.db.collection('iv_classes').doc(id).set(data, { merge: true });
        return { id, ...data };
      }
      const ref = await state.db.collection('iv_classes').add(data);
      return { id: ref.id, ...data };
    },
    async adminDeleteIvClass(id) {
      await ready();
      if (state.mock || !state.db) return;
      await api.assertClassHasNoStudents(id);
      await state.db.collection('iv_classes').doc(id).delete();
    },

    // Fetch every booking linked to a specific class (CNA or IV) so staff
    // can see the roster. Bookings created via the cohort registration
    // forms carry a `classId` field pointing back at the class doc.
    async adminListBookingsByClass(classId) {
      await ready();
      if (state.mock || !state.db) return [];
      if (!classId) return [];
      const snap = await state.db.collection('bookings').where('classId', '==', classId).get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => {
        const ta = a.createdAt && a.createdAt.toDate ? a.createdAt.toDate().getTime() : 0;
        const tb = b.createdAt && b.createdAt.toDate ? b.createdAt.toDate().getTime() : 0;
        return ta - tb;
      });
      return out;
    },

    // Count bookings tied to a class whose status counts toward capacity
    // (confirmed or needs_review — pending/held/cancelled don't take a seat),
    // and write that count to cna_classes.seatsBooked (or iv_classes /
    // staff_classes if the doc lives there). Returns the new count so callers can refresh UI.
    // Idempotent — safe to call after any roster mutation.
    async adminRecountClassSeats(classId) {
      await ready();
      if (state.mock || !state.db || !classId) return null;
      for (const coll of ['cna_classes', 'iv_classes', 'staff_classes']) {
        const ref = state.db.collection(coll).doc(classId);
        const cls = await ref.get();
        if (!cls.exists) continue;
        const snap = await state.db.collection('bookings').where('classId', '==', classId).get();
        let count = 0;
        snap.forEach((d) => {
          const s = (d.data() || {}).status;
          if (s === 'confirmed' || s === 'needs_review') count += 1;
        });
        await ref.update({ seatsBooked: count });
        return count;
      }
      return null;
    },

    // Create a booking attached to a CNA/IV class from the admin roster UI
    // (manually adding a student). Mirrors the customer-side booking shape:
    // nested customer{} object, top-level location/locationName, classId
    // pointing back at the cna_classes / iv_classes doc, status defaulting
    // to "pending" so it doesn't take a seat until staff confirm.
    async adminCreateClassBooking({ classId, classCollection, location, locationName, customer, status, notes, source }) {
      await ready();
      const FV = state.db ? window.firebase.firestore.FieldValue : null;
      const payload = {
        classId: classId || '',
        classCollection: classCollection || 'cna_classes',
        location: location || '',
        locationName: locationName || '',
        customer: {
          firstName: (customer && customer.firstName) || '',
          lastName:  (customer && customer.lastName)  || '',
          email:     (customer && customer.email)     || '',
          phone:     (customer && customer.phone)     || '',
          dob:       (customer && customer.dob)       || '',
          lpnLicense:(customer && customer.lpnLicense)|| ''
        },
        status: status || 'pending',
        notes: notes || '',
        source: source || 'admin-manual',
        shopifyOrderId: '',
        createdAt: FV ? FV.serverTimestamp() : new Date().toISOString()
      };
      if (state.mock || !state.db) return { id: 'mock_' + Math.random().toString(36).slice(2,8), ...payload };
      const ref = await state.db.collection('bookings').add(payload);
      return { id: ref.id, ...payload };
    },
    async reserveIvSeat(classId) {
      await ready();
      if (state.mock || !state.db) return { ok: true, mock: true };
      const ref = state.db.collection('iv_classes').doc(classId);
      const FV = window.firebase.firestore.FieldValue;
      return state.db.runTransaction(async (tx) => {
        const snap = await tx.get(ref);
        if (!snap.exists) { const e = new Error('Class not found'); e.code = 'NOT_FOUND'; throw e; }
        const data = snap.data() || {};
        const total = data.seatsTotal || 0;
        const booked = data.seatsBooked || 0;
        if (total && booked >= total) { const e = new Error('SEATS_FULL'); e.code = 'SEATS_FULL'; throw e; }
        tx.update(ref, { seatsBooked: FV.increment(1) });
        return { ok: true, seatsBooked: booked + 1, seatsTotal: total };
      });
    },

    // Background-check ORI numbers. Stored in collection `ori_numbers`.
    // Each doc: { agency, oriNumber, label, price, shopifyVariantId,
    // active }. Public read (no PII); staff write.
    async adminListOris() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('ori_numbers').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => (String(a.agency || '') + (a.label || a.oriNumber || '')).localeCompare(String(b.agency || '') + (b.label || b.oriNumber || '')));
      return out;
    },
    async adminSaveOri(id, data) {
      await ready();
      if (state.mock || !state.db) return { id: id || 'mock', ...data };
      if (id) { await state.db.collection('ori_numbers').doc(id).set(data, { merge: true }); return { id, ...data }; }
      const ref = await state.db.collection('ori_numbers').add(data);
      return { id: ref.id, ...data };
    },
    async adminDeleteOri(id) {
      await ready();
      if (state.mock || !state.db) return;
      await state.db.collection('ori_numbers').doc(id).delete();
    },
    // Public read for the storefront background-check form. Active ORIs only.
    async getOris() {
      await ready();
      if (state.mock || !state.db) return [];
      let snap;
      try { snap = await state.db.collection('ori_numbers').where('active','==',true).get(); }
      catch (e) { console.warn('[StatMed] getOris failed', e); return []; }
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      out.sort((a, b) => (String(a.agency || '') + (a.label || a.oriNumber || '')).localeCompare(String(b.agency || '') + (b.label || b.oriNumber || '')));
      return out;
    },

    async adminListResourceGroups() {
      await ready();
      if (state.mock || !state.db) return [];
      const snap = await state.db.collection('resource_groups').get();
      const out = [];
      snap.forEach((d) => out.push(Object.assign({ id: d.id }, d.data())));
      return out;
    },
    async adminSaveResourceGroup(id, data) {
      await ready();
      if (state.mock || !state.db) return { id, ...data };
      await state.db.collection('resource_groups').doc(id).set(data, { merge: true });
      return { id, ...data };
    },

    // Create any built-in services / resource_groups from SEED_DATA that are
    // not yet in Firestore. Skips existing docs (never overwrites), and does
    // not touch locations. Used by the "Restore built-ins" admin button so a
    // service defined only in code (e.g. background-check) becomes a real doc.
    // opts (optional): { only: ['services/x', ...] } limits which seed docs
    // are considered; { inactive: true } creates services turned off so old
    // generic built-ins don't silently come back as bookable.
    async adminSeedCatalog(opts) {
      await ready();
      opts = opts || {};
      if (state.mock || !state.db) throw new Error('Firebase is not configured — cannot seed.');
      const seed = namespace.SEED_DATA;
      if (!seed) throw new Error('Seed data not loaded.');
      const results = { created: [], skipped: [] };
      const only = Array.isArray(opts.only) ? opts.only : null;
      const refs = Object.keys(seed)
        .filter((path) => path.indexOf('services/') === 0 || path.indexOf('resource_groups/') === 0)
        .filter((path) => !only || only.indexOf(path) !== -1)
        .map((path) => { const [coll, id] = path.split('/'); return { path, ref: state.db.collection(coll).doc(id) }; });
      const existing = await Promise.all(refs.map(({ ref }) => ref.get()));
      const batch = state.db.batch();
      let writes = 0;
      refs.forEach(({ ref, path }, i) => {
        if (existing[i].exists) { results.skipped.push(path); return; }
        const doc = (opts.inactive && path.indexOf('services/') === 0) ? Object.assign({}, seed[path], { active: false }) : seed[path];
        batch.set(ref, doc, { merge: true });
        results.created.push(path);
        writes++;
      });
      if (writes) await batch.commit();
      return results;
    },

    /* ----- Initial seed ----- */
    async adminSeedInitial({ overwrite } = {}) {
      await ready();
      if (state.mock || !state.db) throw new Error('Firebase is not configured — cannot seed.');
      const seed = namespace.SEED_DATA;
      if (!seed) throw new Error('Seed data not loaded.');
      const results = { created: [], skipped: [], errors: [] };
      const batch = state.db.batch();
      const refs = [];
      for (const path of Object.keys(seed)) {
        if (path.startsWith('_')) continue;
        const [coll, id] = path.split('/');
        if (!coll || !id) continue;
        const ref = state.db.collection(coll).doc(id);
        refs.push({ ref, path });
      }
      // Read all existing docs to decide create vs skip
      const existing = await Promise.all(refs.map(({ ref }) => ref.get()));
      refs.forEach(({ ref, path }, i) => {
        const exists = existing[i].exists;
        if (exists && !overwrite) { results.skipped.push(path); return; }
        batch.set(ref, seed[path], { merge: overwrite !== true });
        results.created.push(path);
      });
      await batch.commit();
      return results;
    },

    /**
     * Call the deployed Shopify-analytics Cloud Function.
     * Pass {action, from, to} (ISO date strings). Sends the current
     * Firebase user's ID token in the Authorization header so the
     * function can verify staff. Throws on non-2xx.
     */
    async analyticsCall({ endpoint, action, from, to } = {}) {
      await ready();
      if (!state.auth) throw new Error('Firebase auth not initialized');
      const user = state.auth.currentUser;
      if (!user) throw new Error('Sign in first');
      const idToken = await user.getIdToken(false);
      const url = endpoint || (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || '';
      if (!url) throw new Error('analyticsUrl not configured. Set window.StatMedConfig.analyticsUrl to the Cloud Function URL.');
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + idToken
        },
        body: JSON.stringify({ action: action || 'summary', from, to })
      });
      const body = await res.json().catch(() => ({ error: 'invalid JSON' }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    },

    /* ----- Low-level handles for the staff admin app (statmed-admin-*.js) -----
       The admin app builds its own queries on top of these so admin features
       don't all have to add methods here. All return null in mock mode. */
    firestore() { return state.mock ? null : state.db; },
    storage() { return state.mock ? null : state.storage; },
    authInstance() { return state.mock ? null : state.auth; },
    fieldValue() { return (!state.mock && window.firebase && window.firebase.firestore) ? window.firebase.firestore.FieldValue : null; },
    // Persistent auth listener (unlike onAuth, keeps firing on sign-in/out).
    // Returns an unsubscribe function.
    onAuthChange(cb) {
      let off = () => {};
      onReady(() => { if (state.auth) off = state.auth.onAuthStateChanged((u) => cb(u)); else cb(null); });
      return () => off();
    },
    async sendPasswordReset(email) {
      await ready();
      if (state.mock || !state.auth) return { ok: true, mock: true };
      await state.auth.sendPasswordResetEmail(String(email || '').trim().toLowerCase());
      return { ok: true };
    },
    // POST {payload} to a Cloud Function in the same project/region as the
    // analytics endpoint (URL derived by swapping the function name), with the
    // signed-in user's ID token. Used for newer endpoints (e.g. businessInvite).
    async callFunction(name, payload) {
      await ready();
      if (state.mock) return { ok: true, mock: true };
      const user = state.auth && state.auth.currentUser;
      if (!user) throw new Error('Sign in first');
      const base = (window.StatMedConfig && window.StatMedConfig.analyticsUrl) || '';
      if (!base) throw new Error('Cloud Functions URL is not configured (theme setting: Analytics URL).');
      const url = base.replace(/\/analytics\/?$/, '/' + name);
      const idToken = await user.getIdToken(false);
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + idToken },
        body: JSON.stringify(payload || {})
      });
      const body = await res.json().catch(() => ({ error: 'Invalid response from ' + name }));
      if (!res.ok) throw new Error(body.error || ('HTTP ' + res.status));
      return body;
    }
  };

  function ready() {
    return new Promise((resolve) => onReady(() => resolve(state)));
  }

  namespace.fb = api;
  namespace.FALLBACK_LOCATIONS = FALLBACK_LOCATIONS;
  // Built-in [[token]] values for site variables. Single source for the
  // storefront (statmed-ui.js initSiteVars) and the staff admin ("Site text"),
  // which shows them and offers "Reset to default". A value saved in
  // settings/site_vars overrides the default.
  namespace.SITE_VAR_DEFAULTS = {
    locations: '4 North Florida locations',
    phone: '(386) 288-8332',       // display
    phone_tel: '+13862888332',     // for tel: links
    email: 'support@statmedtraining.com',
    // Repeated marketing taglines (edit once, updates every page).
    ecard_sameday: 'Same-day AHA eCard',
    ecard_issued_sameday: 'AHA eCard issued same day',
    sameday_cert: 'Same-day certification',
    accepted_nationwide: 'Accepted nationwide',
    aha_training_site: 'American Heart Training Site',
    weekday_weekend: 'Monday - Friday 8am - 4pm',
    // Course-option descriptions (format × certification/bundle).
    desc_acls_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_acls_pals_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_acls_pals_self_guided: "Complete HeartCode ACLS and PALS online, then come in for your in-person skills session.",
    desc_acls_pals_skills_only: "Already completed an approved online cognitive course? Book just the in-person skills session..",
    desc_acls_renewal: "Already had a AHA ACLS certification in the past? This renewal path is for you.",
    desc_acls_self_guided: "Complete HeartCode ACLS online, then come in for a short in-person skills session.",
    desc_acls_skills_only: "Already completed an approved online cognitive course? Book just the in-person skills session.",
    desc_bls_acls_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_bls_acls_pals_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_bls_acls_pals_self_guided: "Complete HeartCode BLS, ACLS, and PALS online, then come in for your in-person skills session.",
    desc_bls_acls_pals_skills_only: "Already completed an approved online cognitive course? Book just the in-person skills session.",
    desc_bls_acls_renewal: "Already had a AHA BLS & ACLS certification in the past? This renewal path is for you.",
    desc_bls_acls_self_guided: "Complete HeartCode BLS and ACLS online, then come in for your skills checks.",
    desc_bls_acls_skills_only: "Already completed an approved online cognitive course? Book just the in-person skills session.",
    desc_bls_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_bls_pals_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_bls_pals_renewal: "Already had a AHA BLS & PALS certification in the past? This renewal path is for you.",
    desc_bls_pals_self_guided: "Complete HeartCode PALS online, then come in for a short skills + megacode check.",
    desc_bls_pals_skills_only: "Already completed an approved online cognitive course? Book just the in-person skills session.",
    desc_bls_renewal: "Already had a AHA BLS certification in the past? This renewal path is for you.",
    desc_bls_self_guided: "Complete online at home, then come in for a short skills check.",
    desc_bls_skills_only: "Already completed an approved online course? Book just the skills check.",
    desc_heartsaver_blended: "AHA online HeartCode plus a scheduled in-person skills session.",
    desc_heartsaver_pediatric_blended: "AHA online HeartCode pediatric module plus a scheduled in-person skills session.",
    desc_heartsaver_pediatric_skills_only: "Already finished an approved online course? Book just the skills check.",
    desc_heartsaver_skills_only: "Already finished an approved online course? Book just the skills check.",
    desc_pals_blended: "AHA HeartCode online plus a scheduled in-person skills session.",
    desc_pals_renewal: "Already had a AHA PALS certification in the past? This renewal path is for you.",
    desc_pals_self_guided: "Complete HeartCode PALS online, then come in for a short in-person skills session.",
    desc_pals_skills_only: "Already completed an approved online cognitive course? Book just the in-person skills session."
  };
  namespace.SEED_DATA = {
    'settings/schedule': { defaultDays: [1,2,3,4,5,6], defaultSlots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'], timezone: 'America/New_York', bookingLeadHours: 24 },

    'resource_groups/cpr-instructor':  { name: 'CPR Instructor', description: 'AHA CPR-family courses. One instructor per location per slot.', services: ['bls-blended','bls-self-guided','bls-skills-only','acls','pals','heartsaver','heartsaver-pediatric','until-help-arrives'] },
    'resource_groups/clinical-room':   { name: 'Clinical Room / CNA Instructor', description: 'Multi-day clinical programs and IV/medication courses.', services: ['cna','cna-exam-only','iv-certification','apd-medication'] },
    'resource_groups/front-desk':      { name: 'Front Desk', description: 'Stand-alone admin services like background checks.', services: ['background-check'] },

    'locations/lake-city': {
      active: true, name: 'Lake City', city: 'Lake City, FL',
      address: '1009 SW Main Blvd, Lake City, FL 32025', phone: '(904) 555-0100',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0860/7868/5484/files/Lake_City_Office.png?v=1750950934',
      hours: { mon:{open:'08:00',close:'17:00'}, tue:{open:'08:00',close:'17:00'}, wed:{open:'08:00',close:'17:00'}, thu:{open:'08:00',close:'17:00'}, fri:{open:'08:00',close:'17:00'}, sat:{open:'09:00',close:'13:00'}, sun: null },
      openDays: [1,2,3,4,5,6],
      slots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'],
      services: ['bls-blended','bls-self-guided','bls-skills-only','acls','pals','heartsaver','heartsaver-pediatric','cna','cna-exam-only','iv-certification','apd-medication','background-check','until-help-arrives'],
      timezone: 'America/New_York'
    },
    'locations/gainesville': {
      active: true, name: 'Gainesville', city: 'Gainesville, FL',
      address: '978 SW 2nd Ave, Gainesville, FL 32601', phone: '(904) 555-0101',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0860/7868/5484/files/Gainesville_Office.png?v=1750950920',
      hours: { mon:{open:'08:00',close:'17:00'}, tue:{open:'08:00',close:'17:00'}, wed:{open:'08:00',close:'17:00'}, thu:{open:'08:00',close:'17:00'}, fri:{open:'08:00',close:'17:00'}, sat:null, sun:null },
      openDays: [1,2,3,4,5],
      slots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'],
      services: ['bls-blended','bls-self-guided','bls-skills-only','acls','pals','heartsaver','heartsaver-pediatric','background-check'],
      timezone: 'America/New_York'
    },
    'locations/jacksonville': {
      active: true, name: 'Jacksonville', city: 'Jacksonville, FL',
      address: '1730 Shadowood Lane, Jacksonville, FL 32207', phone: '(904) 555-0102',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0860/7868/5484/files/Jacksonville_Office.png?v=1750950976',
      hours: { mon:{open:'08:00',close:'17:00'}, tue:{open:'08:00',close:'17:00'}, wed:{open:'08:00',close:'17:00'}, thu:{open:'08:00',close:'17:00'}, fri:{open:'08:00',close:'17:00'}, sat:{open:'09:00',close:'14:00'}, sun:null },
      openDays: [1,2,3,4,5,6],
      slots: ['9:00 AM','11:00 AM','1:00 PM','3:00 PM'],
      services: ['bls-blended','bls-self-guided','bls-skills-only','acls','pals','heartsaver','heartsaver-pediatric','background-check'],
      timezone: 'America/New_York'
    },

    'services/bls-blended':          { active:true, name:'BLS — Blended',            description:'AHA HeartCode online plus a scheduled in-person skills session.', priceDisplay:'$95',  durationMinutes:60,  multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:6, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/bls-self-guided':      { active:true, name:'BLS — Self-Guided',        description:'Online at home, short in-person skills check.',                   priceDisplay:'$85',  durationMinutes:45,  multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:6, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/bls-skills-only':      { active:true, name:'BLS — Skills Only',        description:'Already completed approved online course elsewhere.',              priceDisplay:'$65',  durationMinutes:30,  multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:4, requiresProofUpload:true,  requiresDob:false, adminOnly:false },
    'services/acls':                 { active:true, name:'ACLS',                     description:'Advanced Cardiovascular Life Support.',                           priceDisplay:'$245', durationMinutes:120, multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:6, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/pals':                 { active:true, name:'PALS',                     description:'Pediatric Advanced Life Support.',                                 priceDisplay:'$245', durationMinutes:120, multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:6, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/heartsaver':           { active:true, name:'Heartsaver CPR/AED/FA',    description:'For non-clinical responders and the public.',                     priceDisplay:'$79',  durationMinutes:180, multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:8, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/heartsaver-pediatric': { active:true, name:'Heartsaver Pediatric CPR', description:'For childcare providers, teachers, and parents.',                  priceDisplay:'$79',  durationMinutes:180, multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:8, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/until-help-arrives':   { active:true, name:'Until Help Arrives',       description:'American Red Cross bystander intervention course.',                priceDisplay:'$49',  durationMinutes:90,  multiDay:false, resourceGroup:'cpr-instructor',  blockMode:'slot', maxPerSlot:10,requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/cna':                  { active:true, name:'CNA Training Program',     description:'Full instructor-led CNA program preparing for the Prometric exam.',priceDisplay:'Contact us', durationMinutes:null, durationDays:14, multiDay:true, resourceGroup:'clinical-room',   blockMode:'day',  maxPerSlot:1, requiresProofUpload:false, requiresDob:true,  adminOnly:false },
    'services/cna-exam-only':        { active:true, name:'CNA Exam-Only',            description:'Register for the Prometric CNA exam without full course.',         priceDisplay:'$175', durationDays:1,  multiDay:false, resourceGroup:'clinical-room',   blockMode:'day',  maxPerSlot:1, requiresProofUpload:false, requiresDob:true,  adminOnly:false },
    'services/iv-certification':     { active:true, name:'LPN IV Certification',     description:'In-person IV certification for Florida LPNs.',                    priceDisplay:'$125', durationDays:1,  multiDay:false, resourceGroup:'clinical-room',   blockMode:'day',  maxPerSlot:1, requiresProofUpload:false, requiresDob:false, adminOnly:true  },
    'services/apd-medication':       { active:true, name:'APD Medication Admin',     description:'Basic medication administration, instructor-led.',                priceDisplay:'$95',  durationDays:1,  multiDay:false, resourceGroup:'clinical-room',   blockMode:'day',  maxPerSlot:1, requiresProofUpload:false, requiresDob:false, adminOnly:false },
    'services/background-check':     { active:true, name:'Level 2 Background Check', description:'Available for any ORI number in the State of Florida.',            priceDisplay:'$89',  durationMinutes:30,  multiDay:false, resourceGroup:'front-desk',      blockMode:'slot', maxPerSlot:1, requiresProofUpload:false, requiresDob:false, adminOnly:false }
  };

  // Kick off load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFirebase);
  } else {
    initFirebase();
  }
})();